/* ADDITIONAL JAVASCRIPT HERE */

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {

        //variables for preview section
        var selectedVariantId = $('input[name="Size"]:checked').val();
        console.log("Selected Variant ID: " + selectedVariantId);
        var fabricMain="";
        var bedhead="";
        var base="";
        var baseFeet="";
        var colorMain="";
        var fabric="";
        var adjustVal="";
        var exists = 0;
        var baseExists = 0;
        var headExists = 0;
        var caret='<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';

        $('.bed-shipping > label').append(caret);
        $('.additional-options > label').append(caret);
        $('.build-ensemble > label').append(caret);
        $('.buy-adjustable .spb-label-tooltip > label').append(caret);      


        $('.build-ensemble > span').hide();
        $('.buy-adjustable > span').hide();
        $('.bed-shipping > span').hide();
        $('.additional-options > span').hide();

        $('.build-ensemble > label').on('click', function(e) {
          $('.build-ensemble').toggleClass("bed-collapsed");
          e.preventDefault();
        });
        $('.buy-adjustable .spb-label-tooltip > label').on('click', function(e) {
          $('.buy-adjustable').toggleClass("bed-collapsed");
          e.preventDefault();
        });
      
        $('.additional-options > label').on('click', function(e) {
          $('.additional-options').toggleClass("bed-collapsed");
          e.preventDefault();
        });
        $('.bed-shipping > label').on('click', function(e) {
          $('.bed-shipping').toggleClass("bed-collapsed");
          e.preventDefault();
        });      
        $('.bed-shipping').addClass("bed-collapsed");
        $('.preview-list').hide();

      
      
        $('.select-color .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-fabric-option" style="display:none;"> Preview fabric and colour.</a>');
      $('.select-color-haven .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-fabric-option" style="display:none;"> Preview fabric and colour.</a>');
      $('.select-color-plush .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-fabric-option" style="display:none;"> Preview fabric and colour.</a>');
        $('.base-type-option .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-type-option" style="display:none;"> Base type option reference here.</a>');
        $('.bed-head-type .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="bed-head-option" style="display:none;"> Bedhead type option reference here.</a>');
        $('.adjustable-option .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="adjustable-option"> Adjustable base options here.</a>');            
        //$('.base-feet-options .spb-productdesctextcolor:first-child').append('<a href="#" class="mattress-add-link" id="base-feet-option"> Base feet option reference here.</a>');

          $('.select-color span label').each(function(){
            $(this).click(function(){
              colorMain = $('input',this).val();
              console.log('Color MAIN:'+colorMain);
              filterOptions(selectedVariantId,colorMain); 
              $('.color-selected').html(colorMain);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
              showbasePreview(fabricMain,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            });
          });
          $('.select-color-haven span label').each(function(){
            $(this).click(function(){
              colorMain = $('input',this).val();
              console.log('Color MAIN:'+colorMain);
              filterOptions(selectedVariantId,colorMain); 
              $('.color-selected').html(colorMain);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
              showbasePreview(fabricMain,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            });
          });
          $('.select-color-plush span label').each(function(){
            $(this).click(function(){
              colorMain = $('input',this).val();
              console.log('Color MAIN:'+colorMain);
              filterOptions(selectedVariantId,colorMain); 
              $('.color-selected').html(colorMain);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
              showbasePreview(fabricMain,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            });
          });               


          //fabric selection
          $('.base-fabric-choice .spb-productoptionswatchwrapper').each(function(){
            $(this).click(function(){
              fabric = $('input',this).val();
              console.log('FABRIC: '+fabric);
              showbasePreview(fabric,colorMain,base);
              showheadPreview(fabricMain,colorMain,bedhead);
              generateList(fabricMain,colorMain,base,bedhead,baseFeet);
              displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
            });
          });
          
          // MATTRESS ACTUAL SIZE CHANGE
          $('.template-product-mattress input[type="radio"][name="Size"]').on('change', function(event) {
            exists = 0;
            baseExists = 0;
            headExists = 0;            
            //event.stopPropagation();
            selectedVariantId = $('input[name="Size"]:checked').val();
            console.log("Selected Variant ID: " + selectedVariantId);
            filterOptions(selectedVariantId,colorMain);
            displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);            
            generateList(fabricMain,colorMain,base,bedhead,baseFeet);
            adjustSelection(selectedVariantId);
          });    
      

      // BASE FABRIC UPDATE
      $('.base-fabric-choice .spb-helptext').appendTo('.base-fabric-choice #base_fabric_choice-0-3');
      $('.select-color .spb-helptext').appendTo('.select-color #select_your_fabric_colour_augustus-0-4');
      $('.select-color-haven .spb-helptext').appendTo('.select-color-haven #fabric_colour_haven-0-5');
      $('.select-color-plush .spb-helptext').appendTo('.select-color-plush #select_your_fabric_colour_plush-0-6');
      //$('.base-fabric-choice span label:first-child').addClass('base-fabric-clicked');
      //$('.base-type-option span label:first-child').addClass('base-option-clicked');
      //$('.bed-head-type span label:first-child').addClass('bedhead-option-clicked');
      $('.base-info-section').prepend('<div class="base-info-section-text">Expertly hand crafted with integrated storage, this bed base offers a sophisticated solution for maximizing space without compromising on style.</div>');
      $('.base-info-section').append('<div class="base-info-section-selection">Style Selected: <span class="style-selected"></span><br/>Colour Selected: <span class="color-selected"></span></div>');
      
      $('.bedhead-info-area').prepend('<div class="bedhead-info-section-text">Indulge in the luxurious simplicity of this handcrafted bedhead.  Crafted with the finest materials, its timeless design adds a touch of understated elegance to any bedroom.</div>');
      $('.bedhead-info-area').append('<div class="bedhead-info-section-selection">Style Selected: <span class="bedhead-style-selected"></span><br/>Colour Selected: <span class="color-selected"></span></div>');
      
      fabricMain = $('.base-fabric-clicked input[name="properties[base_fabric_choice]"]:checked').val();
      bedhead = $('.bed-head-type input[name="properties[Bed Head Type]"]:checked').val();
      $('.style-selected').html(fabricMain);
      $('.bedhead-style-selected').html(bedhead);
      $('.base-type-onpage').appendTo('.base-type-select');
      $('.bedhead-type-onpage').appendTo('.bedhead-select');
      
      
      $('.base-fabric-choice span label').each(function(){
        $(this).click(function(){
            $('.base-fabric-choice span label').removeClass('base-fabric-clicked');
          $(this).addClass('base-fabric-clicked');
          fabricMain = $('.base-fabric-clicked input[name="properties[base_fabric_choice]"]:checked').val();
          $('.style-selected').html(fabricMain);
          showbasePreview(fabricMain,colorMain,base);
          showheadPreview(fabricMain,colorMain,bedhead);
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
          displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
        });
      });
      $('.base-type-option span label').each(function(){
        $(this).click(function(){
            $('.base-type-option span label').removeClass('base-option-clicked');
          $(this).addClass('base-option-clicked');
          base = $('.base-type-option input[name="properties[Base Type Option]"]:checked').val();
          showbasePreview(fabricMain,colorMain,base);
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
          displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
          $('.base-type-select').css('height','auto');
          $('.base-type-select').css('overflow','unset');
          $('.base-type-select').css('visibility','visible');
        });
      });  
      $('.bed-head-type span label').each(function(){
        $(this).click(function(){
            $('.bed-head-type span label').removeClass('bedhead-option-clicked');
          bedhead = $('.bed-head-type input[name="properties[Bed Head Type]"]:checked').val();
          $(this).addClass('bedhead-option-clicked');
          $('.bedhead-style-selected').html(bedhead);
          showheadPreview(fabricMain,colorMain,bedhead);
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
          displayVariant(selectedVariantId,colorMain,fabricMain,base,bedhead);
          $('.bedhead-select').css('height','auto');
          $('.bedhead-select').css('overflow','unset');
          $('.bedhead-select').css('visibility','visible');
        });
      }); 

      $('.base-feet-options span label').click(function(){
          baseFeet = $('input[name="properties[Base Feet]"]',this).val();
          generateList(fabricMain,colorMain,base,bedhead,baseFeet);
      });
      
        $('.mattress-add-link').click(function(e){
          e.preventDefault();
          var popupType = $(this).attr('id');
          console.log(popupType);
          $('.overlay').css('visibility','visible');
          $('.overlay').css('opacity','1');
          
          var colorFabric ="";
          if(fabric.includes('Augustus')){fabric = 'Augustus';colorFabric = $('.select-color select').val();}
          if(fabric.includes('Haven')){fabric = 'Haven';colorFabric = $('.select-color-haven select').val();}
          if(fabric.includes('Plush')){fabric = 'Plush';colorFabric = $('.select-color-plush select').val();}             
          bedhead = $('.bed-head-type select').val();
          //base = $('.base-type-option select').val(); 
          colorFabric = colorFabric.split("- ");

          if(popupType == 'base-fabric-option'){
            
            var fabLower = fabric.toLowerCase();
            var colorSrc = $('.'+fabLower+'-swatch .spb-productoptionswatchwrapper .'+colorFabric[1]).attr('data-color-img');
            console.log("Fabric: "+fabLower);
            console.log("Color: "+colorFabric[1]);            
            console.log("Color SRC: "+colorSrc);
            $('.color-selected').html(colorFabric[1]);
            $('.fabric-img img').attr('src',colorSrc);
            $('.bed-popup-content').hide();
            $('.popup .fabric-content').show();
          }
          
          if(popupType == 'base-type-option'){
          
          baseTypeColor = 'cell-'+colorFabric[1].trim();
            $('.basetype-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(baseTypeColor)){}else
              $(this).hide();
          });
            
            $('.bed-popup-content').hide();
            $('.popup .basetype-content').show();
          }
          if(popupType == 'bed-head-option'){
          headTypeColor = 'cell-'+colorFabric[1].trim();
            $('.bedhead-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(headTypeColor)){}else
              $(this).hide();
          });            
            $('.bed-popup-content').hide();
            $('.popup .bedhead-content').show();
          }
          if(popupType == 'adjustable-option'){
            $('.bed-popup-content').hide();
            $('.popup .adjustable-content').show();
          }
          if(popupType == 'base-feet-option'){
            $('.bed-popup-content').hide();
            $('.popup .basefeet-content').show();
          }
          
          if(fabric == 'Augustus'){
            $('h2.fabric-content').text('Fabric Type: Augustus');
            $('.color-options-popup .prod-option-swatch').hide();
            $('.color-options-popup .augustus-swatch').show();
            $('.fabric-main-content').hide();            
            $('.augustus-content').show();   
            
          }
          if(fabric == 'Haven'){
            
            $('h2.fabric-content').text('Fabric Type: Haven');
            $('.color-options-popup .prod-option-swatch').hide();
            $('.color-options-popup .haven-swatch').show();
            $('.fabric-main-content').hide();            
            $('.haven-content').show();            
            
          }
          if(fabric == 'Plush'){
            $('h2.fabric-content').text('Fabric Type: Plush');
            $('.color-options-popup .prod-option-swatch').hide();
            $('.color-options-popup .plush-swatch').show();
            $('.fabric-main-content').hide();            
            $('.plush-content').show();  
            

          }          
          //Bedhead Selection
          if(fabric=='Augustus' && bedhead=='Naya'){
            $('.bedhead-slider').hide();
            $('.naya-augustus').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.naya-augustus').addClass('visible-slider');
          }
          if(fabric=='Augustus' && bedhead=='Stella'){
            $('.bedhead-slider').hide();
            $('.stella-augustus').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.stella-augustus').addClass('visible-slider');
          }
          if(fabric=='Augustus' && bedhead=='Willow'){
            $('.bedhead-slider').hide();
            $('.willow-augustus').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.willow-augustus').addClass('visible-slider');
          }
          if(fabric=='Haven' && bedhead=='Naya'){
            $('.bedhead-slider').hide();
            $('.naya-haven').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.naya-haven').addClass('visible-slider');
          }
          if(fabric=='Haven' && bedhead=='Stella'){
            $('.bedhead-slider').hide();
            $('.stella-haven').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.stella-haven').addClass('visible-slider');
          }
          if(fabric=='Haven' && bedhead=='Willow'){
            $('.bedhead-slider').hide();
            $('.willow-haven').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.willow-haven').addClass('visible-slider');
          }
          // PLUSH
          if(fabric=='Plush' && bedhead=='Naya'){
            $('.bedhead-slider').hide();
            $('.naya-plush').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.naya-plush').addClass('visible-slider');
          }
          if(fabric=='Plush' && bedhead=='Stella'){
            $('.bedhead-slider').hide();
            $('.stella-plush').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.stella-plush').addClass('visible-slider');
          }
          if(fabric=='Plush' && bedhead=='Willow'){
            $('.bedhead-slider').hide();
            $('.willow-plush').show();
            $('.bedhead-slider').removeClass('visible-slider');
            $('.willow-plush').addClass('visible-slider');
          }          

          //Base Selection
          if(fabric=='Haven' && base=='Twin Base'){
            $('.base-slider').hide();
            $('.twin-haven').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.twin-haven').addClass('base-visible-slider');
          }
          if(fabric=='Haven' && base=='Drawer Base'){
            $('.base-slider').hide();
            $('.drawer-haven').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.drawer-haven').addClass('base-visible-slider');
          } 
          if(fabric=='Haven' && base=='Floating Base'){
            $('.base-slider').hide();
            $('.floating-haven').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.floating-haven').addClass('base-visible-slider');
          }
          if(fabric=='Augustus' && base=='Floating Base'){
            $('.base-slider').hide();
            $('.floating-augustus').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.floating-augustus').addClass('base-visible-slider');
          }
          if(fabric=='Augustus' && base=='Twin Base'){
            $('.base-slider').hide();
            $('.twin-augustus').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.twin-augustus').addClass('base-visible-slider');
          }
          if(fabric=='Augustus' && base=='Drawer Base'){
            $('.base-slider').hide();
            $('.drawer-augustus').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.drawer-augustus').addClass('base-visible-slider');
          }     
          // Base PLUSH
          if(fabric=='Plush' && base=='Twin Base'){
            $('.base-slider').hide();
            $('.twin-plush').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.twin-plush').addClass('base-visible-slider');
          }
          if(fabric=='Plush' && base=='Drawer Base'){
            $('.base-slider').hide();
            $('.drawer-plush').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.drawer-plush').addClass('base-visible-slider');
          } 
          if(fabric=='Plush' && base=='Floating Base'){
            $('.base-slider').hide();
            $('.floating-plush').show();
            $('.base-slider').removeClass('base-visible-slider');
            $('.floating-plush').addClass('base-visible-slider');
          }
          
        });        

      $('.popup .close').click(function(){
        $('.overlay').css('visibility','hidden');
          $('.overlay').css('opacity','0');
      })
      /* Change Preview Format of Fabric and Colour base on click */
      $('.fabric-content .prod-option-swatch span .spb-productoptionswatchwrapper').click(function(){
        var colorVal = $('.spb-productoptionswatch',this).attr('data-color-img');
        $('.fabric-img img').attr('src',colorVal);
        $('.color-selected').html($('input',this).val());
      });

      
      /* Select the available size */

      //if ( $(".adjustable-option select option[value='" + valueSelected + "']").val() === undefined) {exists=1;}
      //if(exists == 0){
        //$('.adjustable-option select option').each(function(){
         // if(valueSelected != $(this).val()){
            //$(this).hide();
          //}
        //});        
     // }       
      //INITIAL LOAD
      filterOptions(selectedVariantId,colorMain);


      $(document).on('change', ".base-type-select select", function (e) {
        //console.log('BASE: '+$(this).val());
      });      
      $(document).on('change', ".bedhead-select select", function (e) {
        //console.log('BED: '+$(this).val());
      });        

      //PREVIEW CODE;
      var previewHtml="<div class='preview-list'></div>";
      $('.mattress-notes').prepend(previewHtml);
      $('.bed-shipping').appendTo('.infinite-del-ship');      
      $('.additional-options').appendTo('.infinite-del-ship');
      
      var build = $('input[name="properties[Ensemble]"]:checked').val();
      //console.log("Build "+build);
      previewList(build);
      //build-ensemble
      $(document).on('change', ".build-ensemble input[type=radio]", function (e) {
        build = $('input[name="properties[Ensemble]"]:checked').val();
        //console.log("Build "+build);
        if(build.includes('Yes')){
          $('.preview-list').show();
        }
        if(build.includes('No')){
          $('.preview-list').hide();
        }        
        
        previewList(build);
      });

    function showbasePreview(fabric,color,baseSelection){

          var baseType="";
          var fabricType="";
          var baseDisplay="";
          baseTypeColor = 'cell-'+color.trim();
      
          
          if(fabric!=undefined&&color!=undefined&&baseSelection!=undefined){
            console.log('Fabric: '+fabric);
            console.log('Color: '+color);
            console.log('Base Selection: '+baseSelection);
            if(fabric.includes('Augustus') && baseSelection.includes('Twin')){
              fabricType="augustus";baseType= "twin";               
            }
            if(fabric.includes('Haven') && baseSelection.includes('Twin')){
              fabricType="haven";baseType= "twin";               
            }
            if(fabric.includes('Plush') && baseSelection.includes('Twin')){
              fabricType="plush";baseType= "twin";               
            }
            if(fabric.includes('Augustus') && baseSelection.includes('Floating')){
              fabricType="augustus";baseType= "floating";               
            }
            if(fabric.includes('Haven') && baseSelection.includes('Floating')){
              fabricType="haven";baseType= "floating";               
            }
            if(fabric.includes('Plush') && baseSelection.includes('Floating')){
              fabricType="plush";baseType= "floating";               
            }
            if(fabric.includes('Augustus') && baseSelection.includes('Drawer')){
              fabricType="augustus";baseType= "drawer";               
            }
            if(fabric.includes('Haven') && baseSelection.includes('Drawer')){
              fabricType="haven";baseType= "drawer";               
            }
            if(fabric.includes('Plush') && baseSelection=='Drawer'){
              fabricType="plush";baseType= "drawer";               
            }            
              baseDisplay = "."+baseType+"-"+fabricType;  
              //console.log('Base Selected');
              $('.base-slider').hide();
              $(baseDisplay).attr('style', 'display: block !important');;
            $('.base-slider').removeClass('base-visible-slider');
            $(baseDisplay).addClass('base-visible-slider');            
            $('.basetype-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(baseTypeColor)){
              $(this).show();
            }else
              $(this).hide();
          });
            
          }
    }
    function showheadPreview(fabric,color,headSelection){

          var headType="";
          var fabricType="";
          var headDisplay="";
          var headTypeColor="";
          headTypeColor = 'cell-'+color.trim();      
          
          if(fabric!=undefined&&color!=undefined&&headSelection!=undefined){
            console.log('Fabric: '+fabric);
            console.log('Color: '+color);
            console.log('Head: '+headSelection);
            if(fabric.includes('Augustus') && headSelection.includes('Naya')){fabricType="augustus";headType= "naya";}
            if(fabric.includes('Haven') && headSelection.includes('Naya')){fabricType="haven";headType= "naya";}
            if(fabric.includes('Plush') && headSelection.includes('Naya')){fabricType="plush";headType= "naya";}
            if(fabric.includes('Augustus') && headSelection.includes('Stella')){fabricType="augustus";headType= "stella";}
            if(fabric.includes('Haven') && headSelection.includes('Stella')){fabricType="haven";headType= "stella";}
            if(fabric.includes('Plush') && headSelection.includes('Stella')){fabricType="plush";headType= "stella";}
            if(fabric.includes('Augustus') && headSelection.includes('Willow')){fabricType="augustus";headType= "willow";}
            if(fabric.includes('Haven') && headSelection.includes('Willow')){fabricType="haven";headType= "willow";}
            if(fabric.includes('Plush') && headSelection.includes('Willow')){fabricType="plush";headType= "willow";}            

            headTypeColor = 'cell-'+color.trim();
            headDisplay = "."+headType+"-"+fabricType;
            $('.bedhead-slider').hide();
            $('.bedhead-type-onpage').show();
            $(headDisplay).show();
            $('.bedhead-slider').removeClass('base-visible-slider');
            $(headDisplay).addClass('base-visible-slider');
            $(headDisplay).attr('style', 'display: block !important');
                          
            
            $('.bedhead-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(headTypeColor)){
              $(this).show();
            }else
              $(this).hide();
          });
          }
    }      
    function previewList(preview){
      if(preview != undefined){
        if (preview.indexOf('Yes') !== -1) {
          generateList(fabricMain,colorMain,base,bedhead);   
           $(document).on('change', ".bed-product select", function (e) {
             generateList();  
           });
           $(document).on('change', ".bed-product .buy-adjustable input[name='properties[buy_adjustable_base]']", function (e) {
             generateList();  
           });        
        }else
          $('.preview-list').empty();        
      }

    }
    function displayVariant(size,color,fabric,baseSelection,headSelection){
          var baseType="";
          var headType="";
          var fabricType="";
          var varDisplay="";
          var varheadDisplay="";
          var baseDisplay="";
          var headDisplay="";
      if(size!=undefined&&color!=undefined&&fabric!=undefined){
      console.log('COLOR Variant: '+color);
      console.log('SIZE Variant: '+size);       
      console.log('BASE Variant: '+baseSelection);
     console.log('FABRIC Variant: '+fabric);   
        
            if(fabric.includes('Augustus') && baseSelection.includes('Twin')){fabricType="Augustus";baseType= "Twin";}
            if(fabric.includes('Haven') && baseSelection.includes('Twin')){fabricType="Haven";baseType= "Twin";}
            if(fabric.includes('Plush') && baseSelection.includes('Twin Base')){fabricType="Plush";baseType= "Twin";}
            if(fabric.includes('Augustus') && baseSelection.includes('Floating')){fabricType="Augustus";baseType= "Floating";}
            if(fabric.includes('Haven') && baseSelection.includes('Floating')){fabricType="Haven";baseType= "Floating";}
            if(fabric.includes('Plush') && baseSelection.includes('Floating')){fabricType="Plush";baseType= "Floating";}
            if(fabric.includes('Augustus') && baseSelection.includes('Drawer')){fabricType="Augustus";baseType= "Drawer";}
            if(fabric.includes('Haven') && baseSelection.includes('Drawer')){fabricType="Haven";baseType= "Drawer";}
            if(fabric.includes('Plush') && baseSelection.includes('Drawer')){fabricType="Plush";baseType= "Drawer";}

        varDisplay = baseType+" - "+fabricType;
        console.log('VARIANT DISPLAY:'+varDisplay);
        baseDisplay = baseType.toLowerCase()+"-"+fabricType.toLowerCase();
        console.log('CLASS FOR BASE DISPLAY:'+baseDisplay);
        $('.base-type-select span label').each(function(){
          var baseV = $('input[name="properties[Base Type '+varDisplay+']"]',this).val();
          if(baseV!=undefined){
            if(baseV.includes(size)&&baseV.includes(color)){
              $('.base-type-select-'+baseDisplay).show();
              $('.base-type-select .spb-productoptionswatchwrapper').addClass('hide-base-variant');  
              $(this).removeClass('hide-base-variant');
              console.log('BASE: '+baseV);
              return false;
            }            
          }
        });

          if(headSelection!=undefined){
            if(fabric.includes('Augustus') && headSelection.includes('Naya')){fabricType="Augustus";headType= "Naya";}
            if(fabric.includes('Haven') && headSelection.includes('Naya')){fabricType="Haven";headType= "Naya";}
            if(fabric.includes('Plush') && headSelection.includes('Naya')){fabricType="Plush";headType= "Naya";}
            if(fabric.includes('Augustus') && headSelection.includes('Stella')){fabricType="Augustus";headType= "Stella";}
            if(fabric.includes('Haven') && headSelection.includes('Stella')){fabricType="Haven";headType= "Stella";}
            if(fabric.includes('Plush') && headSelection.includes('Stella')){fabricType="Plush";headType= "Stella";}          
            if(fabric.includes('Augustus') && headSelection.includes('Willow')){fabricType="Augustus";headType= "Willow";}
            if(fabric.includes('Haven') && headSelection.includes('Willow')){fabricType="Haven";headType= "Willow";}
            if(fabric.includes('Plush') && headSelection.includes('Willow')){fabricType="Plush";headType= "Willow";}              
          }
        
        varheadDisplay = headType+" "+fabricType;
        console.log('VARIANT HEAD DISPLAY:'+varheadDisplay);
        headDisplay = headType.toLowerCase()+"-"+fabricType.toLowerCase();
        
        $('.bedhead-select span label').each(function(){
          var headV = $('input[name="properties[Bed Head '+varheadDisplay+']"]',this).val();
          if(headV!=undefined){
            if(headV.includes(size)&&headV.includes(color)){
              $('.bedhead-select-'+headDisplay).show();
              $('.bedhead-select .spb-productoptionswatchwrapper').addClass('hide-base-variant');  
              $(this).removeClass('hide-base-variant');
              console.log('HEAD: '+headV);
              return false;
            }            
          }

        });        
      }
    }      
    function adjustSelection(mattressSize){
        //console.log('Mattress Size:'+mattressSize);
      $('.adjustable-option span label').each(function(){
        
        if($('input',this).val()==mattressSize){
          console.log('Adjustable Label:'+$('input',this).val());
          $('.adjustable-option span label').addClass('hide-ensemble-part');
          $(this).removeClass('hide-ensemble-part');
          return false;
        }else{
          $('.adjustable-option span label').removeClass('hide-ensemble-part');
        }
      });
      
    }
    function filterOptions(mattressValue,colorOption){
      //console.log("Color Main:"+colorOption);
      var colorSplit = colorOption.split("- ");
      /* INITIAL BASE OPTIONS */
      if ( $(".base-type-select select option[value*='" + mattressValue + "']").val() === undefined) {baseExists=1;}  
        //console.log("value: "+mattressValue);
        $('.base-type-select select option').each(function(){
          var splitSize = ($(this).val()).split("/");
          var splitTrim = splitSize[0].trim();
          var splitColor ="";
          if(splitSize[1]!=undefined){
            splitColor = splitSize[1].trim();
          }
          if(mattressValue == splitTrim){
              if(colorSplit[1] == splitColor){
                $(this).show();
              }else
                $(this).hide();
          }else
            $(this).hide();
        });      
      /* INITIAL BED HEAD OPTIONS */
      if ( $(".bedhead-select select option[value*='" + mattressValue + "']").val() === undefined) {headExists=1;}  
        $('.bedhead-select select option').each(function(){
          var splitSize = ($(this).val()).split("/");
          var splitTrim = splitSize[0].trim();
          var splitColor ="";
          if(splitSize[1]!=undefined){
            splitColor = splitSize[1].trim();
          }
          if(mattressValue == splitTrim){
              if(colorSplit[1] == splitColor){
                $(this).show();
              }else
                $(this).hide();
          }else
            $(this).hide();
        });  
    }      

    function generateList(fabric,color,base,bedhead,baseFeet){
        $('.preview-list').empty();
        $('.preview-list').html('<h3>Your Bed Selections are detailed as follows:</h3><div class="preview-list-content"></div><div class="preview-footer">To make any adjustments, please reselect your options</div>');
        $('.preview-list-content').append('<span>Mattress Size: '+selectedVariantId+'</span><br>');
        $('.preview-list-content').append('<span>Mattress Firmness: '+$('.product__title h1').text()+'</span><br>');
        if($('.buy-adjustable input[name="properties[buy_adjustable_base]"]:checked').val() != null){
          $('.preview-list-content').append('<span>Adjustable Base:'+$('.buy-adjustable input[name="properties[buy_adjustable_base]"]:checked').val()+'</span><br>');  
        }
        if(base != ""){
          $('.preview-list-content').append('<span>Base Fabric and Colour: '+fabric+' - '+base+' - '+color+'</span><br>');
        }
        if(baseFeet != null){
          $('.preview-list-content').append('<span>Base Feet: '+baseFeet+'</span><br>');  
        }   
        if(bedhead != ""){
          $('.preview-list-content').append('<span>Bedhead Fabric and Colour: '+fabric+' - '+bedhead+' - '+color+'</span><br>');
        } 
        //if(colorMain != ""){
          //$('.preview-list-content').append('<span>Base and Bedhead Color: '+colorMain+'</span><br>');  
        //}    

        $('.preview-bed-link').click(function(e){
          var fabric = ($('.base-fabric-choice select').val());
          if(fabric.includes('Augustus')){fabric = 'Augustus';}
          if(fabric.includes('Haven')){fabric = 'Haven';}
          if(fabric.includes('Plush')){fabric = 'Plush';} 
          fabric = fabric.toLowerCase();
          
          var bedhead = $('.bed-head-type select').val();
          var base = $('.base-type-option select').val();
          var classText="";
          if (base.indexOf('Twin') !== -1) {
            classText='twin-'+fabric;
          }
          if (base.indexOf('Floating') !== -1) {
            classText='floating-'+fabric;
          }
          if (base.indexOf('Drawer') !== -1) {
            classText='drawer-'+fabric;
          }          
          //console.log(classText);
          
          e.preventDefault();      
          window.dispatchEvent(new Event('resize'));
          var prevpopupType = $(this).attr('id');
          console.log(prevpopupType);
          $('.overlay').css('visibility','visible');
          $('.overlay').css('opacity','1');          
          if(prevpopupType == 'preview-base-type-option'){
            $('.bed-popup-content').hide();
            $('.popup .preview-base-content').show();
            $('.popup .preview-base-content .'+classText).show();
          }
          var str = $('.base-type-select select').val();
          var previewColor = str.split("/");
          previewColor = 'cell-'+previewColor[1].trim();
            $('.preview-base-content .main-carousel .carousel-cell').each(function(){
              $(this).show();
            if($(this).hasClass(previewColor)){
              
            }else
              $(this).hide();
          });
          
        });        
    }  

//ADDITIONAL TEXT
      $('.mattress-notes').prepend("<div class='final-delivery'><div class='final-delivery-list'></div></div>");
      var adjYes = '';
      var ensYes = '';
      if((document.querySelector('input[name="properties[Shipping]"]:checked'))!=null){
        var propShip=document.querySelector('input[name="properties[Shipping]"]:checked').value;  
      }
        $('input[name="properties[buy_adjustable_base]').click(function() {
          adjYes = $(this).val();
          console.log(adjYes+" PLUS "+ensYes);
          finalDel(adjYes,ensYes,propShip)
        });
        $('input[name="properties[Ensemble]').click(function() {
          ensYes = $(this).val();
          console.log(adjYes+" PLUS "+ensYes);
          finalDel(adjYes,ensYes,propShip)
        });
        $('input[name="properties[Shipping]').click(function() {
          propShip = $(this).val();
          finalDel(adjYes,ensYes,propShip)
        });
      

      function finalDel(adjYes,ensYes,propShip){
        var delFee='';
        if(adjYes == "Yes" && (ensYes.indexOf("Yes")!== -1)){
          console.log(adjYes+" PLUS "+ensYes);
          $('.final-delivery-list').empty();
          $('.final-delivery .final-delivery-list').append("<h2>Final Delivery Cost</h2>");
          $('.final-delivery .final-delivery-list').append("<h3>Selected Delivery Option: <span>"+propShip+"</span></h3>");
          if(propShip.indexOf('165')!==-1){
            delFee="$"+(165+100);
            $('.final-delivery .final-delivery-list').append("<h3>Additional Items <span>(more than one Bed item selected) - $100</span><h3>");
          }
          if(propShip.indexOf('275')!==-1){
            delFee="$"+(275+100);
            $('.final-delivery .final-delivery-list').append("<h3>Additional Items <span>(more than one Bed item selected) - $100</span><h3>");  
          }
          if(propShip.indexOf('250km')!==-1){
            delFee="Custom Delivery Fee";
          }          
          
          $('.final-delivery .final-delivery-list').append("<h3>Total Delivery: <span>"+delFee+"</span></h3>");
        }else{
          $('.final-delivery-list').empty();
        }        
      }
      
      
    }, 3000);  


  
    //HIDE ENSEMBLE TEXT
    var divs = document.querySelectorAll(".product-option");
    Array.from(divs).forEach(function(div) {
      if (div.textContent.indexOf("Ensemble") >= 0) {
        div.style.display = "none";
      }
    });


  //dropdown redirect
  $(document).on('change', ".mattress-type-redirects", function (e) {
   window.location = $(this).val();
  });

  var url = window.location;
  console.log("URL: "+url);
  if(url == 'https://creswickwool.com/collections/accessories/glove'){
    window.location = "https://creswickwool.com/collections/womens-gloves";
  }
  if(url == 'https://creswickwool.com/collections/accessories/hats%20and%20beanies' || url == 'https://creswickwool.com/collections/accessories/hats-and-beanies'){
    window.location = "https://creswickwool.com/collections/womens-hat-and-beanies";
  }  
  if(url == 'https://creswickwool.com/collections/accessories/ns'){
    window.location = "https://creswickwool.com/collections/accessories";
  }
  if(url == 'https://creswickwool.com/collections/accessories/scarf'){
    window.location = "https://creswickwool.com/collections/womens-scarf";
  }
  if(url == 'https://creswickwool.com/collections/accessories-gifts/soaps-&-diffusers' || url == 'https://creswickwool.com/collections/accessories-gifts/candle' || url == 'https://creswickwool.com/collections/accessories-gifts/clothing%20protector' || url == 'https://creswickwool.com/collections/accessories-gifts/clothing-protector' || url == 'https://creswickwool.com/collections/accessories-gifts/ns' || url == 'https://creswickwool.com/collections/accessories-gifts/soaps%20&%20diffusers'){
    window.location = "https://creswickwool.com/collections/accessories-gifts";
  }
  if(url == 'https://creswickwool.com//pages/about'){
    window.location = "https://creswickwool.com/pages/about-us";
  }
  //if(url == 'https://creswickwool.com/account/login?return_url=%2Faccount'){
    //if(Cookies.get('reg-account-cookie')){
      //Cookies.remove('reg-account-cookie');
      //window.location = "https://creswickwool.com/pages/activate-email";
    //}
  //}  
    if(url == 'https://creswickwool.com/pages/activate-email'){
      Cookies.remove('reg-account-cookie');
      console.log("ACCOUNT COOKIE: "+Cookies.get('reg-account-cookie'));
      if($('body').hasClass('logged-in')){
        window.location = "https://creswickwool.com/account";
      }
  }    
    if(url == 'https://creswickwool.com/collections/linen'){
    window.location = "https://creswickwool.com/collections/linen-homewares";
  }  
    if(url == 'https://creswickwool.com/collections/collections-recycled-wool'){
    window.location = "https://creswickwool.com/collections/recycled-wool-blankets";
  }  
    if(url == 'https://creswickwool.com/collections/australian-made'){
    window.location = "https://creswickwool.com/collections/australian-made-2";
  }    
  
  
  

  //hover image collection
  setTimeout(function() {
    console.log('Color Clicked INIT');
    $('.template-collection .ss__result').each(function(){


      //ADD REWARDS PRICING TAG ON 
      var dataValue = $('.wishlist-engine',this).data("product_id");
      //console.log('DATAVALUE: '+dataValue);
      //if (dataValue && dataValue.includes('6986754949229')) {
        //$('.card__badge',this).append('<span class="badge essential-card-badge" style="">Rewards Price</span>');
      //}
      //if (dataValue && dataValue.includes('6960381689965')) {
        //$('.card__badge',this).append('<span class="badge essential-card-badge" style="">Rewards Price</span>');
      //}      

      

      //if($('body').hasClass('col-ultra-luxury-mattress')){
        //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;display:block !important;">New</span>');
        //$('.ss__badge--sale').html('40% Off');
      //}
      //if($('body').hasClass('template-collection-mattresses')){
        //$('.ss__badge--sale').html('40% Off');
      //}      
      //if($('body').hasClass('col-new-spring-clothing-1') || $('body').hasClass('col-new-spring-accessories-24') || $('body').hasClass('col-womens-resort-collection') || $('body').hasClass('col-womens-bamboo-collection') || $('body').hasClass('col-womens-linen-collection')){
        //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');
      //}      
      //if($('body').hasClass('col-new-winter-accessories') || $('body').hasClass('col-new-winter-2025') || $('body').hasClass('col-womens-winter-clothing') || $('body').hasClass('col-new-winter-unique-2025') || $('body').hasClass('col-new-winter-mens-clothing')){
        //if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
          //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');  
        //}
      //}
      if($('body').hasClass('col-recycled-wool-blankets') || $('body').hasClass('col-recycled-wool-throws')){
          if($('.card__badge',this).find('.ss__badge--recycled').length !== 0){
            
          }else{
            $('.card__badge',this).append('<span id="NoMediaStandardBadge-template--14601942564973-grid-6986750460013-Colour-Beige Chocolate" class="badge badge--bottom-left color-accent-2 ss__badge--recycled" style=""><img src="https://cdn.shopify.com/s/files/1/0559/9825/1117/files/recycle_cricle-hires-white_green.png?v=1704847831" alt="Recycled"></span>');
          }
      }
        


      
      $('.colour-fieldset label.color-swatch',this).click(function(){
          var result = $(this).closest('.ss__result');
          $('.ss__result__image .media.media--hover-effect>img+img',result).addClass('second-img');
          console.log(result);
          console.log('Color Clicked');
          //$('.badge-clearance-outlet',result).html('CLEARANCE OUTLET');

        
        //run the update again
        //setTimeout(function() {
         // if($('.card__badge .ss__badge--sale',result).hasClass('badge-clearance-outlet')){
          //$('.badge-clearance-outlet',result).html('CLEARANCE OUTLET');
          //}
       // }, 1000);  
          
      });  

      //size change
      $('.size-fieldset',this).click(function(){
      var result1 = $(this).closest('.ss__result');
      //$('.badge-clearance-outlet',result1).html('CLEARANCE OUTLET');
     });   

    //multi badge  
    var multiTitle = $('.ss__result__name',this).text();
    var packMessage="";  
      
        if (multiTitle.indexOf('2 Pack') !== -1) {
          packMessage ='2 Pack';
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
          packMessage ='3 Pack';
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
          packMessage ='4 Pack';
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
          packMessage ='10 Pack';
        }
        if (multiTitle.indexOf('12 Pack') !== -1) {
          packMessage ='12 Pack';
        }      
        //console.log('Pack Message: '+packMessage);
          if(packMessage !=''){
            if($('.card__content .main-prod-card-link',this).find('.card-multi-badge').length !== 0){}else{
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');  
          }
        } 
      
    });
  }, 3000);  

  $('.col-afterdark-promo .banner__media').append('<img src="https://cdn.shopify.com/s/files/1/0559/9825/1117/files/Mobile_After_Dark_414x155_1.jpg?v=1693548559" class="hide-desktop">');

  //Upsell button
  $('.icon-cart').click(function(){
     $(".upsell-container").toggleClass("show-upsell"); 
  });
  $('.drawer__close').click(function(){
    $("cart-drawer").removeClass("move-cart");
  }); 
  
  //Check li number in megamenu sublist
  $('.mega-menu').each(function(){
   // console.log($('.mega-menu__list > li',this).length);
    var lenClass = 'length-'+$('.mega-menu__list > li',this).length;
    $(this).addClass(lenClass);
  });

  setTimeout(function() {
    var yotpo_rating = $('.product__info-container .yotpo-sr-bottom-line-score').html();
    if(yotpo_rating != undefined){
      console.log('Yotpo Rating: '+parseFloat(yotpo_rating.trim()));
      var yotpo_num = parseFloat(yotpo_rating.trim());
        $('.product__info-container .yotpo-sr-bottom-line-score').html('<span class="yotpo-extra-text">See Reviews</span>');
        $('.product__info-container .yotpo-sr-bottom-line-score').css("cssText", "display: block !important;");

      $('#yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-button[aria-label*="reviews"]').each(function() {
        let text = $(this).attr('aria-label');
        let match = text.match(/(\d+)\s+reviews/); // find the number before "reviews"

        if (match) {
          let reviewsCount = match[1];
          $('.product__info-container .yotpo-sr-bottom-line-left-panel').prepend('<span class="based-on-reviews">Based on '+reviewsCount+' reviews</span>');
        }
      });        
    }


    //HIDE NEW IF THERE IS A SALE TAG
    const outletSKU = ["40558917779565","40506177880173","40506177912941","40558917812333","40506177945709","40506177978477","40506184368237","40506184401005","40506184433773","40506184466541","40506189807725","40506189840493","40506189873261","40506187808877","40506187841645","40506187874413","40506187907181","40506187939949","40558937374829","41740473761901","40506201014381","40976058318957","40506201047149","40506257703021","40580659576941","40580659609709","40580613865581","40580613898349","40580613931117","40580644601965","40580644634733","40580644667501","40580644700269","40580644733037","40580644765805","40580644798573","40580608589933","40580608622701","40580608655469","40580608688237","40580608721005","40580608753773","40580608786541","40580608819309","40580608852077","40580608884845","40580608917613","40580608950381","40580608983149","40580609015917","40580609048685","40580609081453","40580609114221","40580609146989","40580664492141","40580662132845","40580662165613","40580662689901","40580662722669","40580662755437","40580662788205","40580662820973","40580662853741","40580662886509","40580662919277","40580662952045","40580662984813","40580663017581","40580663050349","40580684021869","40580684054637","40580684120173","40580684185709","40636530262125","40580698800237","40580698833005","40580698865773","40636530294893","40580698898541","40632295489645","40632295522413","40636530327661","40580698964077","40580698996845","40580699029613","40582759612525","40582759645293","40580700864621","40580700897389","40580700930157","40580700962925","40714424287341","40714424320109","40714424352877","40652379553901","40652379586669","40652379619437","40652379652205","40652379684973","40652379717741","40652379750509","40652379783277","40652379816045","40652379848813","40652379881581","40652379914349","40652379947117","40652379979885","40652380012653","40729443008621","40729443041389","40729443074157","40729443106925","40729442943085","40729442975853","40789295071341","40789295104109","40789295136877","40789295169645","40789295202413","40789295267949","9330905025091","9330905025107","9330905025114","9330905026838","9330905025121","9330905026845","9330905026791","9330905026814","9330905027354","9330905027361","9330905027408","9330905033706","9330905027378","9330905027385","9330905027392","9330905027415","9330905005994","9330905006007","9330905006014","9330905026401","9330905026425","93565424","9330905027705","93489461","9330905007356","9330905026463","9330905026487","9330905026494","9330905007417","9330905007424","9330905007431","9330905009602","9330905025091","9330905025107","93535434","9330905026791","93530859","9330905001262","9330905027699","93281973","93316743","93228855","9330905027378","9330905027385","9330905027392","9330905027415","93227810","93018050","93018036","93018043","93018005","93000406","93000116","93000185","93000260","93066218","93066219","93000413","93009119","93000123","93000192","9330905028740","9330905028757","9330905028764","9330905028771","9330905028788","9330905016341","9330905016358","93012157","93007467","93012164","93012126","93005104","93005166","93005043","93005210","93223867","93005241","93007481","93007498","93009492","93266208","93075705","9330905028924","93064405","93261067","93013611","93025720","93022354","9330905002429","9330905027699","93227940","93227902","93023146","93025461","93025454","93025485","93025478","93533034","93025508","93025522","93025515","93025492","93226318","93064419","93065347","93227919","93348003","93348027","93348065","93348072","93352406","987654321`","9330905027880","9330905027897","93428637","93536073","93495707","9330905027330","9330905027347","93525053","93515849","93536059","93536066","93516839","93525046","93525039","9330905006229","9330905006236","93515856","93525060","9330905004850","9330905004829","9330905004836","93388689","93533218","93533225","9330905014866","9330905014873","93420150","93429719","93429702","9330905013333","9330905013340","9330905013357","9330905013364","9330905013371","9330905034420","93442206","9330905002511","9330905002528","93568883","93568869","93568876","93568852","93568845","9330905033997","9330905034000","9330905034017","9330905034024","9330905034031","93016575","93007771","93012317","93000369","93217910","93428620","93007818","93000161","93000093","93000376","93000383","93000246","93000109","93000178","93063627","9330905013319","9330905013173","9330905013289","9330905013203","9330905013234","93464178","9330905013166","9330905013197","9330905013272","9330905013302","93536035","93515832","9330905025138","9330905025145","93562874","93562881","93562898","93515870","9330905025046","9330905025039","9330905025077","9330905025060","93515894","9330905028894","9330905028900","9330905028917","9330905033713","9330905033720","93523592","93522250","93569835","93522281","93522311","93489461","93489454","9330905013241","9330905013210","9330905013296","9330905013180","9330905013326","93516518","93516792","93516808","93339476","93465847","93465830","93519434","93568630","93533096","93063637","93025751","93022651","93038430","93022699","93535434","93523653","93523646","93530866","93530859","93526074","93526227","93526210","93530903","93530897","93526173","93526234","93533058","93533072","93533065","93533041","93533089","93558372","93558358","93536646","93558389","93558495","93558488","9330905029228","9330905029235","93562911","93562904","9330905001255","9330905001262","9330905001279","9330905001286","9330905005444","9330905005451","9330905018369","9330905005918","9330905005925","9330905005895","9330905005901","9330905005932","9330905005949","9330905005956","9330905005963","9330905029242","9330905029259","9330905005970","9330905005987","9330905006243","9330905016419","9330905016426","9330905016433","9330905009350","9330905009367","9330905010035","9330905009411","9330905009428","9330905010059","9330905009374","9330905009381","9330905010042","9330905022717","9330905022724","9330905022731","9330905022748","9330905022755","9330905022663","9330905022670","9330905022687","9330905022694","9330905022700","9330905022762","9330905022779","9330905022786","9330905022793","9330905022809","9330905022830","9330905022847","9330905022816","9330905022823","9330905022854","9330905022861","9330905025091","9330905025107","9330905025114","9330905026838","9330905025121","9330905026845","9330905026791","9330905026814","9330905027354","9330905027361","9330905027408","9330905033706","9330905027378","9330905027385","9330905027392","9330905027415","9330905033812","9330905033850","9330905033874","9330905033881","9330905033898","9330905033904","93411240","93411226","93411233","93411257","93443623","9330905038336","9330905038343","9330905038350","9330905038367","9330905038374","93281973","93227247","93316736","93316743","93228855","9330905016327","9330905016334","93334570","93334556","9330905015931","93339384","93339513","93339452","93339537","93339568","93339698","93339575","93339704","93339711","93339865","93516495","93489447","9330905024841","9330905024858","9330905024865","9330905024872","9330905024889","9330905024896","9330905024902","9330905024919","9330905024926","9330905026616","9330905026623","9330905026630","9330905026647","9330905026654","9330905026661","93001113","93515030","93016483","93054669","93069566","93070484","93074960","93074943","93352390","93352413","93522083","93522090","9330905000586","9330905000562","93506236","93506250","9330905000616","9330905000579","93515047","9330905000593","9330905000609","9330905029631","9330905029648","93277396","9330905016044","93063789","9330905016051","93063790","93063792","9330905016068","93530750","93063791","93530767","9330905016075","9330905016082","9330905024100","9330905024117","9330905024124","9330905026692","9330905026708","9330905026715","9330905026722","9330905026739","9330905026746","9330905026753","93233958","93530781","93530774","93530842","93530835","93530811","93568739","93568722","93531351","93531375","9330905037902","9330905037919","93568753","93568746","9330905037926","93568760","93568814","93568807","93568777","9330905025428","93568791","93568821","93489140","93372527","93264396","93283090","93283137","93283199","93437851","93510691","93510707","93510714","93510721","93510738","93510745","93510752","93510769","93510776","93516853","93532556","93296700","93562935","93567060","93567213","93516938","93516907","93516921","93565370","93523868","93523400","93523479","93565486","93565493","93522632","93522564","93522588","93522571","93522595","93522694","93522649","93522687","93522656","93535588","93535601","93535571","93535595","93535564","93536172","93536141","93536264","9330275076525","93565240","93565264","93565233","93565257","93565271","93565332","93565318","93565325","93565363","93565349","93565356","93567022","93567046","93567015","93567008","93567039","93566995","93567053","93567176","93567190","93567091","93567084","93567183","93567077","93567206","9330275093454","9330275093478","9330275093485","9330275093416","9330275093379","9330275093393","9330905036097","9330905036219","93414128","9330905038329","9330905038312","93443104","93335294","9330905038299","93395212","93409117","93410298","9330905038305","9330905023868","93570107","93569033","93569040","93569019","9330905028337","9330905028344","9330905028313","9330905028320","9330905028290","9330905028306","93520416","93526296","93526319","93526302","93568678","93526326","9330905023530","9330905023547","9330905023554","9330905023561","9330905023578","93066749","93070722","93230797","93075131","93075133","93075132","93075130","93089741","93060790","93289696","93289702","93289689","93289719","93443647","93396592","93384018","93396585","93396578","93383998","93477703","93397056","93523233","93516419","93516433","93516426","9330905022076","93516969","93516983","93516976","93516952","93523851","93535632","93535618","93535649","93535625","93536578","93536592","93536585","93536561","93536608","93000772","93309028","93023269","93516396","93025447","93214363","9330905007356","9330905024186","9330905024155","9330905024131","9330905024162","9330905024179","93570053","93570060","93570084","93535717","9330905028818","93535724","93535748","9330905028825","93535731","93562942","9330905033270","9330905033829","93522397","9330905033287","9330905033294","93007870","93069961","93507233","93515474","93060302","9330905032396","93026604","9330905014859","93522380","93053440","93059093","93063788","93005302","93038485","93063784","93038478","93007733","93038461","9330905014842","93073119","9330905014811","9330905006649","93483339","93483322","93483377","93568289","93515672","9330905006625","9330905007387","9330905007394","9330905006618","93515481","9330905033683","93568210","9330905007349","93515689","93515733","9330905006632","9330905006601","9330905026371","9330905006588","9330905006717","9330905006564","9330905006700","9330905028276","9330905006656","9330905006595","9330905026364","9330905033690","9330905026340","93515702","9330905006670","93568241","9330905006694","9330905006687","9330905014453","9330905004386","93523813","93524834","9330905027903","93524841","93523820","9330905014897","93526067","93568982","9330905015818","9330905015801","9330905033300","9330905033317","9330905015719","9330905026500","9330905026470","9330905026487","9330905026555","9330905026463","93515665","9330905026548","9330905026517","9330905026524","9330905026531","9330905026494","9330905007363","93568159","93568227","93528351","93530392","93533102","93533409","93533393","93533416","93533423","9330905001545","93535663","93535670","9330905015788","9330905015795","9330905015740","9330905015757","9330905025411","9330905015764","9330905015733","9330905015726","93558440","93558464","93558457","93568173","9330905026562","9330905026418","9330905026395","9330905026401","93568180","9330905026425","9330905006748","9330905006755","93569002","9330905005871","9330905005857","9330905005888","9330905005864","9330905006335","9330905006342","9330905007561","9330905007578","9330905006366","9330905006663","9330905026388","9330905006724","9330905026357","9330905007066","9330905015863","9330905015870","9330905025084","9330905026432","9330905026449","9330905026456","9330905027637","9330905027644","9330905027651","9330905027668","9330905027675","9330905033324","9330905033935","9330905033942","93565530","93565547","93565554","93565608","93565592","93565615","9330905033966","9330905033973","9330905033980","93063419","93063417","93063416","93063418","93063415","93063759","93205641","93063421","93063422","93063420","93033107","93033091","93033077","93033084","93033060","93046411","93054584","93033114","93044615","93033121","93070500","93070499","93070498","93066649","93070497","93205719","93205726","93070501","93070502","93070503","9330905033836","9330905033843","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330910000000","9330905005994","9330905006007","9330905006014","9330905026401","9330905026425","93565424","9330905027705","93558495","93558488","93489461","9330905007356","9330905026463","9330905026487","9330905026494","9330905007417","9330905007424","9330905007431","9330905009602","9330905025091","9330905025107","93535434","9330905026791","93530859","9330905001262","9330905027699","93281973","93316743","93228855","9330905027378","9330905027385","9330905027392","9330905027415"]
    
    $('.ss__result--item').each(function(){

    var col_link = $('.card__content .main-prod-card-link',this).attr('href');  
    //console.log("Collection LINK: "+col_link);  

    if(col_link.indexOf('twin-pack') != -1){
          //$('.card__badge .ss__badge--sale',this).html('NEW');
          //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:rgb(56, 66, 47) !important');
      
    }else{
      if($('.card__badge span',this).hasClass('ss__badge--sale')){
          $('.card__badge .ss__badge--new',this).hide();
      }      
    }  

    var i;
    for (i = 0; i < outletSKU.length; ++i) {
       if(col_link.indexOf(outletSKU[i]) != -1){
        //$('.card__badge .ss__badge--sale',this).html('CLEARANCE OUTLET');
        //$('.card__badge .ss__badge--sale',this).addClass('badge-clearance-outlet');
        //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#BB252A !important');

         if($('body').hasClass('template-collection-outlet')){
            //$('.card__badge .ss__badge--sale').html('CLEARANCE OUTLET');
            //$('.card__badge .ss__badge--sale').addClass('badge-clearance-outlet');
            //$('.card__badge .ss__badge--sale').attr('style', 'background-color:#BB252A !important');           
         }else{
           //$('.price__container',this).prepend("<span class='col-outlet-grid'>Enter <a href='https://creswickwool.com/collections/outlet' target='_blank'>Outlet</a> for further 20% off</span>");
         }

         
       }
    }      

const winterSKU = ["45134792261741","45134792228973","45058891841645","45058891808877","45058907963501","45058908029037","45058907996269","45058908061805","45144881397869","45144881430637","45144881463405","45192940388461","45192940421229","45192940453997","45193427615853","45193427419245","45193427353709","45193427320941","45193427484781","45193427550317","45193427648621","45193427452013","45193427386477","45193427288173","45193427517549","45193427583085","45059310944365","45059310878829","45059310813293","45059311009901","45059311075437","45059310977133","45059310911597","45059310846061","45059311042669","45059311108205","45199430484077","45199430254701","45199430090861","45199429992557","45199430287469","45199430451309","45199430549613","45199430189165","45199430156397","45199430058093","45199430353005","45199430418541","45199430516845","45199430221933","45199430123629","45199430025325","45199430320237","45199430385773","45059341254765","45059341058157","45059340992621","45059340959853","45059341123693","45059341189229","45144968069229","45059341090925","45059341025389","45059340927085","45059341156461","45059341221997","45183070699629","45183070601325","45183070568557","45183070535789","45183070634093","45183070666861","45178807189613","45178806993005","45178806927469","45178806894701","45178807058541","45178807124077","45178807222381","45178807025773","45178806960237","45178806861933","45178807091309","45178807156845","45178822819949","45178822721645","45178822688877","45178822656109","45178822754413","45178822787181","45212178546797","45212178350189","45212178251885","45212178219117","45212178382957","45212178481261","45212178514029","45212178317421","45212178284653","45212178186349","45212178415725","45212178448493","44204387598445","44204387401837","44204387336301","44204387303533","44204387467373","44204387532909","44204387631213","44204387434605","44204387369069","44204387270765","44204387500141","44204387565677","44950456107117","44950456074349","44950456041581","44950456139885","44950456172653","45183440945261","45183440912493","45183440879725","45183440978029","45183441010797","45179029749869","45179029717101","45179029684333","45179029782637","45179029651565","45179029815405","45134942339181","45134942273645","45134942208109","45134942404717","45134942470253","45134942371949","45134942306413","45134942240877","45134942437485","45134942503021","44204370100333","44204370133101","44204370165869","44204370198637","44204370231405","44204370264173","44288962723949","44288962756717","44288962789485","44288962822253","44288962855021","44288962887789","45047558832237","45047558799469","45047558766701","45047558865005","45047558733933","45047558897773","45179311095917","45179311063149","45179311030381","45179311128685","45179310997613","45179311161453","45134969405549","45134969340013","45134969274477","45134969471085","45134969241709","45134969536621","45134969438317","45134969372781","45134969307245","45134969503853","45134969208941","45134969569389","45039359492205","45039359459437","45039359426669","45039359524973","45039359393901","45039359557741","45135042379885","45135042347117","45135042314349","45135042412653","45135042445421","44974940356717","44974940323949","44974940291181","44974940389485","44974940422253","45135045984365","45135045951597","45135045918829","45135046017133","45135046049901","45047597989997","45047597957229","45047597924461","45047598022765","45047597891693","45047598055533","44975086370925","44975086338157","44975086305389","44975086403693","44975086436461","44975086829677","44975086698605","44975086534765","44975086960749","44975087091821","44975086764141","44975086665837","44975086567533","44975086862445","44975086993517","44975086731373","44975086600301","44975086469229","44975086895213","44975087059053","45182627053677","45182626988141","45182626922605","45182627119213","45182627184749","44975086796909","44975086633069","44975086501997","44975086927981","44975087026285","45182627020909","45182626955373","45182626889837","45182627086445","45182627151981","45135049195629","45135049162861","45135049130093","45135049228397","45135049097325","45135049261165","45047646683245","45047646650477","45047646617709","45047646716013","45047646748781","45135106867309","45135106834541","45135106801773","45135106900077","45135106769005","45135106932845","45059389620333","45059389554797","45059389522029","45059389653101","45059389489261","45059389718637","44975215444077","44975215345773","44975215476845","44975215378541","44975215509613","44975215411309","44975216754797","44975216722029","44975216689261","44975216787565","44975216820333","44978252906605","44978252677229","44978252447853","44978253070445","44978253299821","44978252808301","44978252644461","44978252513389","44978252972141","44978253135981","44978252742765","44978252546157","44978252382317","44978253004909","44978253267053","45182627381357","45182627315821","45182627250285","45182627446893","45182627512429","44978252873837","44978252611693","44978252415085","44978253037677","44978253201517","45182627348589","45182627283053","45182627217517","45182627414125","45182627479661","44975270461549","44975270396013","44975270363245","44975270527085","44975270592621","44975270494317","44975270428781","44975270330477","44975270559853","44975270625389","44975418802285","44975418769517","44975418736749","44975418835053","44975418867821","45185339326573","45185339261037","45185339228269","45185339392109","45185339162733","45185339359341","45185339293805","45185339195501","45185339424877","45185339129965","45135108538477","45135108571245","45135108604013","45135108636781","45135108669549","45135108702317","45135108735085","45145048776813","45047946182765","45047946215533","45047946248301","45047946281069","45047946313837","45047946346605","45183661211757","45183661178989","45183661146221","45183661244525","45183661113453","44204374032493","44204373999725","44204373966957","44204374065261","44204373934189","44204374098029","45048062378093","45048062345325","45048062312557","45048062410861","45048062279789","45048062443629","44288979173485","44288979107949","44288979042413","44288979239021","44288979009645","44288979304557","44288979206253","44288979140717","44288979075181","44288979271789","44288978976877","44288979337325","44977666392173","44977666359405","44977666293869","44977666490477","44977666228333","44977666556013","45047675977837","45047675945069","45047675912301","45047676010605","45047675879533","45047676043373","44977666424941","44977666326637","44977666261101","44977666457709","44977666195565","44977666523245","45183703515245","45183703482477","45183703449709","45183703548013","45183703416941","45183703580781","45047679320173","45047679287405","45047679254637","45047679352941","45047679221869","45047679385709","44977693360237","44977693327469","44977693294701","44977693393005","44977693261933","44977693425773","45135119155309","45135119122541","45135119057005","45135119220845","45135118991469","45135119286381","45185452900461","45185452834925","45185452769389","45185452965997","45185452933229","45185452867693","45185452802157","45185452998765","45185515651181","45185515618413","45185515585645","45185515683949","44977699782765","44977699717229","44977699651693","44977699848301","44977699586157","44977699946605","44977699815533","44977699749997","44977699684461","44977699881069","44977699618925","44977699913837","45183931744365","45183931711597","45183931678829","45183931777133","45183931646061","45183931809901","45193580347501","45185604550765","45185604517997","45185604485229","45185604583533","45185604452461","45185604616301","45193581461613","45205649096813","45135132950637","45135132983405","45135133016173","45135132917869","45135132885101","45135132852333","45048407326829","45048407097453","45048407064685","44204361056365","44204360990829","44204360925293","44204361121901","44204360892525","44204361187437","44204361089133","44204361023597","44204360958061","44204361154669","44204360859757","44204361220205","45154561753197","45154561720429","45154561687661","45154561785965","45154561818733","44204364300397","44204364234861","44204364169325","44204364365933","44204364136557","44204364431469","44204364333165","44204364267629","44204364202093","44204364398701","44204364103789","44204364464237","45154561917037","45154561884269","45154561851501","45154561949805","45154561982573","45135147729005","45135147696237","45135147663469","45135147761773","45135147630701","45135147794541","44977775706221","44977775673453","44977775640685","44977775738989","44977775607917","44977775771757","45059397320813","45059397288045","45059397255277","45059397353581","45059397222509","45059397386349","45062985220205","45062985187437","45062985154669","45062985252973","45062985121901","45062985285741","44977775509613","44977775476845","44977775444077","44977775542381","44977775411309","45048170119277","45135147958381","45135147925613","45135147892845","45135147991149","45135147860077","45135148023917","44977775313005","44977775280237","44977775247469","44977775345773","44977775214701","45094489260141","44977776296045","44977776263277","44977776230509","44977776328813","44977776197741","44977776361581","44977776066669","44977776033901","44977776001133","44977776099437","44977775968365","44977776132205","45179488829549","45179488796781","45179488764013","45179488862317","45179488731245","45179488895085","45179489026157","45179488993389","45179488960621","45179489058925","45179488927853","45179489091693","45048190369901","45048190337133","45048190304365","45048190402669","45048190271597","45048190435437"]      
    var i1;  
    for (i1 = 0; i1 < winterSKU.length; ++i1) {
       if(col_link.indexOf(winterSKU[i1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
            $('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');  
          }
       }
    }        
    
const wintersaleSKU = ["43250335514733","43250335580269","43250335547501","43258820722797","43250335678573","43250335613037","43250335645805","43258820755565","43250335776877","43250335744109","43250335711341","43250335842413","43250335809645","43258820788333","43250335875181","43250335940717","43258820821101","43250335973485","43250335907949","43250336071789","43250336039021","43250336006253","41518750957677","41518750990445","41518751023213","41518751055981","41518751088749","41518751121517","41518751154285","41518751187053","41518751219821","41518751252589","41518751285357","41518751318125","40631337386093","40590975500397","40631470063725","40631470030957","42253341753453","40631469998189","40580702994541","42336767606893","42336767541357","42336767508589","42336767475821","40580671537261","40729496584301","40729496617069","40580671209581","40580671340653","40580671504493","40580671799405","40678040600685","40678040797293","40678040862829","40678040633453","40678040830061","40678040895597","41250237939821","41250237972589","41250238005357","41250238070893","41250238103661","41250238136429","41770822205549","42336525287533","42336525320301","42336528433261","42336528498797","42336528531565","42336528564333","42113158185069","42113158217837","42113158250605","42113158283373","42113107001453","42113107034221","42113107066989","42113107099757","42113107132525","42113180303469","42113180369005","42113180401773","42113180434541","42113180467309","42387213877357","42387213910125","42387213942893","42336713244781","42336713277549","42336713375853","42336713506925","42113158316141","42113158414445","42113158479981","42084892934253","42113158545517","42113158611053","42113158348909","42113158381677","42113158447213","42084892901485","42113158512749","42113158578285","42113090158701","42113090191469","42334551703661","42334551736429","42334551769197","42334551801965","42387215843437","42387215876205","43083386355821","43083386716269","43083386781805","43083386847341","43083386388589","43083386421357","43083386486893","43083386552429","43083386617965","43083386749037","43083386814573","42349426704493","42349426737261","42349433946221","42349433978989","42349434011757","42363973369965","42363973402733","42363973435501","42363973468269","42387214336109","42363977662573","42363977728109","42363977793645","42363977859181","42387214434413","42363977629805","42363977695341","42363977760877","42363977826413","42387214401645","42253269762157","42253269860461","42334526144621","42334526177389","42334526210157","42744041439341","42744041734253","42744041635949","42744041668717","42744041799789","42742135783533","42742135685229","42742135816301","42742135849069","42742135980141","42742136111213","42244104192109","42244104224877","42244104257645","42244104290413","42244104323181","42336279560301","42336279593069","42336279625837","42336279658605","42336279691373","42336528367725","42336528400493","42336528466029","42113089208429","42113091272813","42285886832749","42285886865517","42285886898285","42285886931053","42318282719341","41256326332525","42099148193901","42099148226669","42323794100333","42323794133101","42323794165869","42323794198637","42323794231405","42336828555373","42336828588141","42336828620909","42336828653677","42336828686445","42323794034797","42323794067565","42323795116141","42323795148909","42267082358893","42267082489965","42267082588269","42267082653805","42267082850413","42367965200493","42367965954157","42367965986925","42367966380141","42367966412909","42367967756397","42333944348781","42333944381549","42333944414317","42333944447085","42333944479853","42333944512621","41474958360685","41478418497645","40580624482413","41197218824301","40580686446701","40580686577773","40580686676077","40580686741613","40580686413933","40580686545005","40580686643309","40580686708845","40580676812909","41474958491757","41489715331181","41478418235501","40506164772973","40506164740205","40506164707437","40580674060397","40580692443245","40714341711981","40714341843053","40714341318765","40580612685933","40580612882541","40580693327981","40580667244653","40580645650541","40580645683309","40580645912685","40580645978221","40580700504173","40580644962413","40506233323629","40580644241517","40580671307885","40580642340973","40506198196333","40580695556205","41593261359213","40580621664365","42267082457197","40558923776109","40558923907181","40558923972717","40558924038253","40558924103789","40558923841645","40558924169325","40558922498157","40558922563693","40678041583725","40506169524333","40506169360493","40506169426029","40506169393261","42797106888813","42797106921581","42797957808237","40713243066477","40713243033709","41246898585709","41639771570285","41639771701357","41246898716781","41639771635821","41246898651245","41246898684013","41639771668589","41639771603053","40580670161005","40580670292077","40580670423149","40580670095469","40580670357613","40580651122797","40580651155565","40580651384941","40580651450477","40580651679853","40580608065645","40580608131181","40580608295021","40580608426093","40580608491629","41200358490221","41200358555757","41200358588525","41200358719597","41256323612781","41256323711085","41256323743853","41256323776621","41256323973229","41380760387693","41256324038765","41256324071533","41256324104301","41256324137069","41256324268141","41256324497517","41256324530285","41256324595821","41256324661357","41256324726893","41200358916205","41197222789229","41197222887533","41197222985837","41197223182445","41593261490285","41593261588589","41593261719661","41593261523053","41593261686893","41593261752429","41593261817965","41593261916269","41593262014573","41593262080109","41593262145645","41593262211181","41593261949037","41593262047341","41249167704173","41249167900781","41249167933549","41249167769709","41249530085485","41249530118253","41249530151021","41197222264941","41197222330477","41197222396013","41197222461549","41197222166637","41197222232173","41197222297709","41197222363245","42931316260973","42931316326509","42931316392045","41256325283949","41256325906541","41256325677165","41256325939309","41256326299757","41250570502253","41250570567789","41250570633325","41250570797165","41250570961005","40620904743021","41256326430829","41256326463597","41197218693229","40968003944557","40968004042861","40968004108397","40968004239469","40968004305005","40968003977325","40968004010093","40968004075629","40968004206701","40968004272237","40580636573805","40580685070445","40580685693037"];   
    var w1;  
    for (w1 = 0; w1 < wintersaleSKU.length; ++w1) {
       if(col_link.indexOf(wintersaleSKU[w1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--sale')){
            //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important');
            //$('.card__badge .ss__badge--sale',this).attr('style', 'background-cocerlylor:#fce072 !important;color:#000 !important');
            //$('.card__badge .ss__badge--sale',this).html('EOS Sale');
          }
       }
    } 

//POSSUM CUSTOM BADGE         
//}     
    
    });  

    $('.ss__pagination__page a').click(function(){
      
      setTimeout(function() {
      if($('body').hasClass('template-collection-outlet')){
        //$('.card__badge .ss__badge--sale').html('CLEARANCE OUTLET');
        $('.card__badge .ss__badge--sale').addClass('badge-clearance-outlet');
        $('.card__badge .ss__badge--sale').attr('style', 'background-color:#BB252A !important');           
      }      
      }, 1000);   

    });
    
  }, 3000);    

  //https://creswickwool.com/account/login?return_url=%2Fpages%2Ftest-subscriber-page

  $('#rich-text-115653194 p a').click(function(){
    $('.kl-private-reset-css-Xuajs1 .klaviyo-close-form').click();  
  });

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    //console.log("Scroll: "+scroll);
if (window.matchMedia("(max-width: 767px)").matches)
{
    if (scroll >= 850) {
        $(".template-product").addClass("product-scrolled");
    } else {
        $(".template-product").removeClass("product-scrolled");
    }

    if (scroll < (1700+($('.cart-items').height()))) {
        $(".template-cart").addClass("cart-scrolled");
    } else {
      $(".template-cart").removeClass("cart-scrolled");
    }
  
    //if (scroll >= 1600) {
       // $(".template-cart").addClass("cart-scrolled");
    //} else {
      //$(".template-cart").removeClass("cart-scrolled");
    //}
  
}

//CHECK FOR SCROLLING TO UPDATE
    $('.ss__result--item').each(function(){

      //if($('body').hasClass('col-new-winter-accessories') || $('body').hasClass('col-new-winter-2025') || $('body').hasClass('col-womens-winter-clothing') || $('body').hasClass('col-new-winter-unique-2025') || $('body').hasClass('col-new-winter-mens-clothing')){
        //if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
          //$('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:rgb(56, 66, 47) !important;">New</span>');  
        //}
      //}      

    var col_link = $('.card__content .main-prod-card-link',this).attr('href');  
      if($('.card__badge span',this).hasClass('ss__badge--sale')){
          $('.card__badge .ss__badge--new',this).hide();
      }      
      
const wintersaleSKU = ["43250335514733","43250335580269","43250335547501","43258820722797","43250335678573","43250335613037","43250335645805","43258820755565","43250335776877","43250335744109","43250335711341","43250335842413","43250335809645","43258820788333","43250335875181","43250335940717","43258820821101","43250335973485","43250335907949","43250336071789","43250336039021","43250336006253","41518750957677","41518750990445","41518751023213","41518751055981","41518751088749","41518751121517","41518751154285","41518751187053","41518751219821","41518751252589","41518751285357","41518751318125","40631337386093","40590975500397","40631470063725","40631470030957","42253341753453","40631469998189","40580702994541","42336767606893","42336767541357","42336767508589","42336767475821","40580671537261","40729496584301","40729496617069","40580671209581","40580671340653","40580671504493","40580671799405","40678040600685","40678040797293","40678040862829","40678040633453","40678040830061","40678040895597","41250237939821","41250237972589","41250238005357","41250238070893","41250238103661","41250238136429","41770822205549","42336525287533","42336525320301","42336528433261","42336528498797","42336528531565","42336528564333","42113158185069","42113158217837","42113158250605","42113158283373","42113107001453","42113107034221","42113107066989","42113107099757","42113107132525","42113180303469","42113180369005","42113180401773","42113180434541","42113180467309","42387213877357","42387213910125","42387213942893","42336713244781","42336713277549","42336713375853","42336713506925","42113158316141","42113158414445","42113158479981","42084892934253","42113158545517","42113158611053","42113158348909","42113158381677","42113158447213","42084892901485","42113158512749","42113158578285","42113090158701","42113090191469","42334551703661","42334551736429","42334551769197","42334551801965","42387215843437","42387215876205","43083386355821","43083386716269","43083386781805","43083386847341","43083386388589","43083386421357","43083386486893","43083386552429","43083386617965","43083386749037","43083386814573","42349426704493","42349426737261","42349433946221","42349433978989","42349434011757","42363973369965","42363973402733","42363973435501","42363973468269","42387214336109","42363977662573","42363977728109","42363977793645","42363977859181","42387214434413","42363977629805","42363977695341","42363977760877","42363977826413","42387214401645","42253269762157","42253269860461","42334526144621","42334526177389","42334526210157","42744041439341","42744041734253","42744041635949","42744041668717","42744041799789","42742135783533","42742135685229","42742135816301","42742135849069","42742135980141","42742136111213","42244104192109","42244104224877","42244104257645","42244104290413","42244104323181","42336279560301","42336279593069","42336279625837","42336279658605","42336279691373","42336528367725","42336528400493","42336528466029","42113089208429","42113091272813","42285886832749","42285886865517","42285886898285","42285886931053","42318282719341","41256326332525","42099148193901","42099148226669","42323794100333","42323794133101","42323794165869","42323794198637","42323794231405","42336828555373","42336828588141","42336828620909","42336828653677","42336828686445","42323794034797","42323794067565","42323795116141","42323795148909","42267082358893","42267082489965","42267082588269","42267082653805","42267082850413","42367965200493","42367965954157","42367965986925","42367966380141","42367966412909","42367967756397","42333944348781","42333944381549","42333944414317","42333944447085","42333944479853","42333944512621","41474958360685","41478418497645","40580624482413","41197218824301","40580686446701","40580686577773","40580686676077","40580686741613","40580686413933","40580686545005","40580686643309","40580686708845","40580676812909","41474958491757","41489715331181","41478418235501","40506164772973","40506164740205","40506164707437","40580674060397","40580692443245","40714341711981","40714341843053","40714341318765","40580612685933","40580612882541","40580693327981","40580667244653","40580645650541","40580645683309","40580645912685","40580645978221","40580700504173","40580644962413","40506233323629","40580644241517","40580671307885","40580642340973","40506198196333","40580695556205","41593261359213","40580621664365","42267082457197","40558923776109","40558923907181","40558923972717","40558924038253","40558924103789","40558923841645","40558924169325","40558922498157","40558922563693","40678041583725","40506169524333","40506169360493","40506169426029","40506169393261","42797106888813","42797106921581","42797957808237","40713243066477","40713243033709","41246898585709","41639771570285","41639771701357","41246898716781","41639771635821","41246898651245","41246898684013","41639771668589","41639771603053","40580670161005","40580670292077","40580670423149","40580670095469","40580670357613","40580651122797","40580651155565","40580651384941","40580651450477","40580651679853","40580608065645","40580608131181","40580608295021","40580608426093","40580608491629","41200358490221","41200358555757","41200358588525","41200358719597","41256323612781","41256323711085","41256323743853","41256323776621","41256323973229","41380760387693","41256324038765","41256324071533","41256324104301","41256324137069","41256324268141","41256324497517","41256324530285","41256324595821","41256324661357","41256324726893","41200358916205","41197222789229","41197222887533","41197222985837","41197223182445","41593261490285","41593261588589","41593261719661","41593261523053","41593261686893","41593261752429","41593261817965","41593261916269","41593262014573","41593262080109","41593262145645","41593262211181","41593261949037","41593262047341","41249167704173","41249167900781","41249167933549","41249167769709","41249530085485","41249530118253","41249530151021","41197222264941","41197222330477","41197222396013","41197222461549","41197222166637","41197222232173","41197222297709","41197222363245","42931316260973","42931316326509","42931316392045","41256325283949","41256325906541","41256325677165","41256325939309","41256326299757","41250570502253","41250570567789","41250570633325","41250570797165","41250570961005","40620904743021","41256326430829","41256326463597","41197218693229","40968003944557","40968004042861","40968004108397","40968004239469","40968004305005","40968003977325","40968004010093","40968004075629","40968004206701","40968004272237","40580636573805","40580685070445","40580685693037"];   
    var w1;  
    for (w1 = 0; w1 < wintersaleSKU.length; ++w1) {
       if(col_link.indexOf(wintersaleSKU[w1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--sale')){
            //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important');
            //$('.card__badge .ss__badge--sale',this).attr('style', 'background-color:#fce072 !important;color:#000 !important');
            //$('.card__badge .ss__badge--sale',this).html('EOS Sale');
          }
       }
    }

//POSSUM CUSTOM BADGE    
     
//}        
    var multiTitle = $('.ss__result__name',this).text();
    var packMessage="";  
      
        if (multiTitle.indexOf('2 Pack') !== -1) {
          packMessage ='2 Pack';
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
          packMessage ='3 Pack';
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
          packMessage ='4 Pack';
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
          packMessage ='10 Pack';
        }
        if (multiTitle.indexOf('12 Pack') !== -1) {
          packMessage ='12 Pack';
        }      
        //console.log('Pack Message: '+packMessage);
          if(packMessage !=''){
            if($('.card__content .main-prod-card-link',this).find('.card-multi-badge').length !== 0){}else{
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
          }
        } 

const springSKU = ["43310799552621","43310799519853","43310799421549","43310799618157","43310799356013","43310799683693","43310799585389","43310799487085","43310799454317","43310799650925","43310799388781","43310799716461","43310801322093","43310801289325","43310801191021","43310801387629","43310801125485","43310801453165","43310801354861","43310801256557","43310801223789","43310801420397","43310801158253","43310801485933","43311224062061","43311223996525","43311223930989","43311224127597","43311223898221","43311224193133","43311224094829","43311224029293","43311223963757","43311224160365","43311223865453","43311224225901","43323783938157","43323783872621","43323783807085","43323783970925","43323783905389","43323783839853","40580658036845","40580657971309","40580657905773","40580658102381","40580657873005","40580658167917","43292217933933","43292217901165","43292217868397","43292217966701","43292217835629","43292217999469","42387215581293","42387215548525","42387215515757","42387215614061","42387215482989","42387215646829","40506151272557","40506151239789","40506151207021","40506151305325","40506151174253","40506151338093","42387214794861","42387214762093","42387214729325","42387214827629","42387214696557","42387214860397","41830692880493","41830692749421","41830692585581","41830693011565","41830692421741","41830693142637","41830692978797","41830692847725","41830692716653","41830693109869","41830692552813","41830693240941","40580639785069","40580639653997","40580639555693","40580640079981","40580639293549","40580640243821","40582755156077","40582755123309","40582755090541","40582755188845","40582755057773","40582755221613","43288512528493","43288512561261","43288512594029","43288512626797","43288512659565","43288512692333","43288513544301","43288513577069","43288513609837","43288513642605","43288513675373","43288513708141","43318702276717","43318702243949","43318702178413","43318702342253","43318702112877","43318702407789","43318702309485","43318702211181","43318702145645","43318702375021","43318702080109","43318702440557","43288513216621","43288513249389","43288513282157","43288513314925","43288513347693","43288513380461","43318718890093","43318718824557","43318718759021","43318718955629","43318718693485","43318719021165","43318718922861","43318718857325","43318718791789","43318718988397","43318718726253","43318719053933","43292218228845","43292218196077","43292218163309","43292218261613","43292218130541","43292218294381","43288512921709","43288512954477","43288512987245","43288513020013","43288513052781","43288513085549","41834501963885","41834501996653","43302701564013","43288513118317","43288512495725","41834501963885","41834501996653","43288512430189","43302701564013","43288511971437","43288512397421","43288513151085","43288513118317","43311597158509","43311597092973","43311597125741","43311597158509","43311597191277","43311597224045","43311597256813","43288508170349","43288508203117","43288508235885","43288508268653","43288508301421","43288508760173","43288508792941","43288508825709","43288508858477","43288508891245","43288509153389","43288509186157","43288509218925","43288509251693","43288509284461","43288510857325","43288510890093","43288510922861","43288510955629","43288510988397","43288511021165","43555647324269","43555647357037","43555647389805","43555647422573","43288509677677","43288509710445","43288509743213","43288509775981","43288509808749","43288509841517","43288507580525","43288507613293","43288507646061","43288507678829","43288507711597","43288507744365","43288509349997","43288509382765","43288509415533","43288509448301","43288509481069","43288509513837","43292218032237","43288508956781","43288508989549","43288509022317","43288509055085","43288509087853","43288507383917","43288507416685","43288507449453","43288507482221","43288507514989","43288507809901","43288507908205","43288507973741","43288508039277","43288508104813","43288507777133","43288507875437","43288507940973","43288508006509","43288508072045","43288508137581","43288508399725","43288508432493","43288508498029","43288508563565","43288508629101","43288508694637","43288508366957","43288508530797","43288508596333","43288508661869","43288508727405"];
    var i1;  
    for (i1 = 0; i1 < springSKU.length; ++i1) {
       if(col_link.indexOf(springSKU[i1]) != -1){
          if($('.card__badge span',this).hasClass('ss__badge--new')){}else{
            $('.card__badge',this).append('<span class="badge badge--bottom-left color-accent-2 ss__badge--new" style="background:#2e2e2e !important;">New</span>');  
          }
       }
    }      

      //OVERRIDE FOR FROM IN PRODUCT CARD
      
      //let originalText = $(".price__container .price-item--last",this).text();
      //if (originalText.toLowerCase().includes("from")){      
        //$(".price__container .price-item--last",this).html('');
        //$(".price__container .price-item--last",this).empty();
        //let cleanedText = originalText.replace(/from/gi, "");
        //$(".price__container .price-item--last",this).html(cleanedText);         

        //let text = $(".price__container .price-item--last",this).text(); // Get text from the div
        
        // Split into words, filter out duplicates, and join back
        //let uniqueWords = text.split(" ").filter((word, index, self) => self.indexOf(word) === index).join(" ");
        //$(".price__container .price-item--last",this).text(uniqueWords); // Set the cleaned text back to the div
        
      //}      
    
    });  
  
});

$('.prod-clearance-btn').click(function(e){
  e.preventDefault();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'VH4SL6']);  
});

/* CUSTOM CODE */
setTimeout(function() {
    
$('.needsclick.go1515943218').html('Receive $20 Off');

$('.needsclick.go1515943218').click(function(){
    $('.needsclick.go1515943218').html('Receive $20 Off');
});
$('#email_105192842').keyup(function(){
    $('.needsclick.go1515943218').html('Receive $20 Off');
});

$('#rich-text-105192848 p span').html('Welcome20 Discount Code can only be used once in one transaction and cannot be used in conjunction with any other offer or Discount Code.');
$('#rich-text-105192848 p span').text('Welcome20 Discount Code can only be used once in one transaction and cannot be used in conjunction with any other offer or Discount Code.');
$('#rich-text-105192846 div:nth-child(2)').hide();
var wishURL = window.location;
//$('.register-popup-h3').html('<a href="/account/login">Already a Member? Log In </a>');
if(wishURL == 'https://creswickwool.com/pages/wishlist'){
  $('.reg-variable-text').html('Save your Wishlist by entering your details below!');
}else{
  //$('.reg-variable-text').html('Become a Member and <br>receive $20 Off');  
}  

    const mouseEvent = e => {
      if (!e.toElement && !e.relatedTarget) {
            document.removeEventListener('mouseout', mouseEvent);
        if(Cookies.get('exit-cookie')){
            if(wishURL == 'https://creswickwool.com/pages/wishlist'){
              $('.reg-variable-text').html('Save your Wishlist by entering your details below!');
            }else{
              //$('.reg-variable-text').html('Become a Member and <br>receive $20 Off');  
            }  
        }                          
      }
    };
    document.addEventListener('mouseout', mouseEvent); 

    $('.register-popup-btn').click(function(){
          if(wishURL == 'https://creswickwool.com/pages/wishlist'){
              $('.reg-variable-text').html('Save your Wishlist by entering your details below!');
            }else{
              //$('.reg-variable-text').html('Become a Member and <br>receive $20 Off');  
            }          
    });  

}, 3000);

  //$('.cart-cs-message .add-customer-text p').text('Trusted 5 Star Natural Fibre Experts');
  $('.not-logged-in .cart-cs-message a:first-child').click(function(e){
    e.preventDefault();
    $('.register-popup-overlay').css('display','block');
    $('.register-popup-overlay').css('visibility','visible');
    $('.register-popup-overlay').css('opacity','1');      
  });
  $('.not-logged-in .cart-cs-message a:last-child').click(function(e){
    e.preventDefault();
    $('.login-overlay').css('display','block');
    $('.login-overlay').css('visibility','visible');
    $('.login-overlay').css('opacity','1');      
  });

  //UPSELL PRICE TOTAL UPDATE
  var qtyVal = $('.upsell-botanical-bug-buster-40 .upsell-item__qty .quantity__input').val();
  var upsellPrice = $('.upsell-botanical-bug-buster-40 .upsell-price').attr('data-price');
  var upsellTotal = (upsellPrice * qtyVal).toFixed(2);
  $('.upsell-botanical-bug-buster-40 .upsell-total').html('$'+upsellTotal);

  $('.upsell-botanical-bug-buster-40 .upsell-item__qty .quantity__button').click(function(){
    qtyVal = $('.upsell-botanical-bug-buster-40 .upsell-item__qty .quantity__input').val();
    upsellTotal = (upsellPrice * qtyVal).toFixed(2);
    $('.upsell-botanical-bug-buster-40 .upsell-total').html('$'+upsellTotal);
  });

  //UPSELL PRICE TOTAL UPDATE
  var qtyVal_2 = $('.upsell-water-resistance-picnic-rug-check .upsell-item__qty .quantity__input').val();
  var upsellPrice_2 = $('.upsell-water-resistance-picnic-rug-check .upsell-price').attr('data-price');
  console.log('QTY2: '+qtyVal_2);
  var upsellTotal_2 = (upsellPrice_2 * qtyVal_2).toFixed(2);
  $('.upsell-water-resistance-picnic-rug-check .upsell-total').html('$'+upsellTotal_2);

  $('.upsell-water-resistance-picnic-rug-check .upsell-item__qty .quantity__button').click(function(){
    qtyVal_2 = $('.upsell-water-resistance-picnic-rug-check .upsell-item__qty .quantity__input').val();
    upsellTotal_2 = (upsellPrice_2 * qtyVal_2).toFixed(2);
    $('.upsell-water-resistance-picnic-rug-check .upsell-total').html('$'+upsellTotal_2);
  }); 
});

// Using the onload event handler property
window.onload = (event) => {
// YOTPO REWARDS OVERRIDE
setTimeout(function() {  
  $(document).on('click','.yotpo-action-button-widget .yotpo-button-style', function(){
    console.log('button click');
    setTimeout(function() {
    $('.yotpo-rewards-history-tile .yotpo-grid-row').each(function(){
      var inner_Text = $('.row-action-column .yotpo-inner-text',this).text();
      console.log('REWARD_TEXT: '+inner_Text);
      if(inner_Text.indexOf('Welcome to Merino Bronze') != -1){
        $('.yotpo-copy-code-button',this).addClass('tier-reward-code');
      }else{
        $('.yotpo-copy-code-button',this).addClass('default-reward-code');
      }
      var discountCode = $('.row-status-column .yotpo-inner-text',this).text();
      $('.yotpo-copy-code-button',this).click(function(){
        console.log(discountCode);
        var discountURL = 'https://creswickwool.com/discount/'+discountCode;
        console.log(discountURL);
        $.ajax({
          url:discountURL,
          success: function(data) {
            console.log("Your discount has been applied!");
          }
        });         
      });
      $('.tier-reward-code',this).click(function(){
        alert('Select OK/Close to automatically place this discount code into your cart, which applies for orders over $100.');
          if(window.location.pathname == '/cart'){
            window.location.href = "https://creswickwool.com/cart";  
          }
      });
      $('.default-reward-code',this).click(function(){
        alert('Select OK/Close to automatically place Discount Code into cart.');
          if(window.location.pathname == '/cart'){
            window.location.href = "https://creswickwool.com/cart";  
          }
      });      
    });
    }, 2000);          
  });  

// discount field
      $('.cart-discount-form').click(function(e){
        e.preventDefault();
        var dCode = $('.cart-discount-text').val();
        if(dCode != ''){
          var dCodeURL = 'https://creswickwool.com/discount/'+dCode;  
          console.log(dCodeURL);
          $.ajax({
            url:dCodeURL,
            success: function(data) {
              console.log("Your discount has been applied!");
              window.location.href = "https://creswickwool.com/cart";
            }
          });          
        }
        
        
         
      });  
  
  //$('.ss__badge--australian-made img').attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');
    }, 3000);       
  //$('.ss__badge--australian-made img').attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');

var wishURL = window.location;  
  if(wishURL == 'https://creswickwool.com/pages/wishlist'){
    if($('body').hasClass('not-logged-in')){
      if(Cookies.get('wishlist-cookie')){
        $('.register-popup-overlay').css('display','none');        
      }      
      else{
        $('.register-popup-overlay').css('display','block');
        $('.register-popup-overlay').css('visibility','visible');
        $('.register-popup-overlay').css('opacity','1'); 
      }       
    }
  }

const videoLinks = document.querySelectorAll('.video-link');
const videoPopup = document.getElementById('videoPopup');
const videoFrame = document.getElementById('videoFrame');
const closeButton = document.querySelector('.video-close');

videoLinks.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default link behavior
        const videoId = this.getAttribute('data-video-id');
        videoFrame.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`; // Set video src to autoplay
        videoPopup.style.display = 'block'; // Show the popup
    });
});
if(closeButton != undefined){
  closeButton.addEventListener('click', function() {
      videoPopup.style.display = 'none'; // Hide the popup
      videoFrame.src = ''; // Stop the video when closing
  });
}   

window.addEventListener('click', function(event) {
    if (event.target === videoPopup) {
        videoPopup.style.display = 'none'; // Hide the popup if clicking outside
        videoFrame.src = ''; // Stop the video
    }
});  

  $('.recover-pword').click(function(){
    $('.recover-form').show();
    $('#customer_login').hide();
    $('h1#login').hide();
    $('h2#login').hide();
  });  


    $('.ss__pagination__page').click(function(){
      
        console.log('pagination clicked');
        setTimeout(function() {
      console.log('timeout set');
      $('.template-collection .ss__result').each(function(){
        $('.ss__badge--australian-made img',this).attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');
      var multiTitle = $('.ss__result__name',this).text();          
        if (multiTitle.indexOf('2 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
              $('.card__content .main-prod-card-link',this).append('<div class="card__badge bottom right ss__badge__container card-multi-badge"><span class="multi-badge badge">'+packMessage+'</span>');
        }         
      });
      }, 1000);
     
    });

  $('.infiniteoptions-price').appendTo('.infinite-container');
  $('.infiniteoptions-price').prepend('<span>Bed Ensemble Total Price</span>');



  if($('.product__info-container').find('.yotpo-widget-instance').length !== 0){

    var textReview = $('.yotpo-reviews-carousel-widget-clear .glide__slides .glide__slide:first-child .review-content').text().trim();
    console.log('Review Text: '+textReview);
    if(textReview != ''){
      $('.review-snippet').show();
    }
    $('.review-snippet span').html(String(textReview.substr(0,75)+'...'));
  }


  //template-product-base-bedheads
  //template-product-mattress

    $('.ss__load-more').click(function(){
      
        console.log('pagination clicked');
        setTimeout(function() {
      console.log('timeout set');
      $('.template-collection .ss__result').each(function(){
        $('.ss__badge--australian-made img',this).attr('src','https://cdn.shopify.com/s/files/1/0559/9825/1117/files/au_made_c962b8f6-7fab-43b9-9aa5-49b7fd1d9776.webp?v=1726112641');
        var multiTitle = $('.ss__result__name',this).text();  
        var packMessage='';
        if (multiTitle.indexOf('2 Pack') !== -1) {
          packMessage ='2 Pack';
        }
        if (multiTitle.indexOf('3 Pack') !== -1) {
          packMessage ='3 Pack';
        }
        if (multiTitle.indexOf('4 Pack') !== -1) {
          packMessage ='4 Pack';
        }
        if (multiTitle.indexOf('10 Pack') !== -1) {
          packMessage ='10 Pack';
        } 
        
          if(packMessage !=''){
            if($('.card__badge',this).find('.multi-badge').length !== 0){}else{
              //$('.card__badge',this).append('<span class="multi-badge badge">'+packMessage+'</span>');  
          }
        } 

      $('.ss__badge__container span',this).each(function(){
          console.log('THIS: '+$(this).attr('class'));
          if($(this).hasClass('ss__badge--sale')){
            
            $(this).siblings('.ss__badge--new').hide();
          }
      });        
        
      });

      //if($('body').hasClass('template-collection-mattresses')){
        //$('.ss__badge--sale').html('40% Off!');
      //}    

          
      }, 1000);
     
    });
  

    setTimeout(function() {
      if($('.product__info-container').find('.yotpo-widget-instance').length !== 0){
        
        var textReview = $('.yotpo-reviews-carousel-widget-clear .glide__slides .glide__slide:first-child .review-content').text().trim();
        console.log('Review Text: '+textReview);
        if(textReview != ''){
          $('.review-snippet span').html(String(textReview.substr(0,65)+'...'));
          $('.review-snippet').show();  
        }
        
      }
  }, 1000);  
  
};

  if($('body').hasClass('template-product-base-bedheads') || $('body').hasClass('template-product-mattress')){
    var pathArray = window.location.pathname.split( '/' );
    if(pathArray.includes('collections')){
      let currentUrl = window.location.href;
      let startMarker = 'collections';
      let endMarker = 'products';
      let newUrl = currentUrl.replace(new RegExp(startMarker + '.*?' + endMarker, 'g'), 'products');
      window.location.href = newUrl;      
    }    
  }

//document.querySelector('#is-gift').addEventListener('change', function() { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Is this a gift?': this.checked ? 'Yes' : 'No' } }) }); });
$('.lusso-text-snippet a').click(function(){
  $('#lusso-product-description .morelink').click();  
});

$("div[id*='wishlist_engine_product_page_RFmFKW']").appendTo('.template-product-mattress .product-form__buttons');
$("div[id*='wishlist_engine_product_page_B3tBM7']").appendTo('.template-product-lusso-mattress .product-form__buttons');
$("div[id*='wishlist_engine_product_page_xNNWjL']").appendTo('.template-product-base-bedheads .product-form__buttons');

document.addEventListener('DOMContentLoaded', function () {
  // Get the "More" links
  const moreLinks = document.querySelectorAll('.size-guide-popuplink');
  const contLink = document.querySelectorAll('.prod-contact-btn');
  const popup = document.getElementById('product-popup');
  const closeBtn = document.querySelector('.popup-close');
  const productDescription = document.getElementById('product-description');

  $('.size-guide-popuplink').click(function(event){
    event.preventDefault();
    $('.default-size-guide').show();
    $('.product-contact-popup').hide();
    popup.style.display = 'flex';  // Show the popup    
  });  
  $('.prod-contact-btn').click(function(event){
    event.preventDefault();
    $('.default-size-guide').hide();
    $('.product-contact-popup').show();
    popup.style.display = 'flex';  // Show the popup    
  });    

  // Close the popup
  if(closeBtn != null){
    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
      $('.default-size-guide').hide();
      $('.product-contact-popup').hide();
    });    
  }


  // Close the popup when clicking outside of it
  window.addEventListener('click', function (event) {
    if (event.target === popup) {
      popup.style.display = 'none';
      $('.default-size-guide').hide();
      $('.product-contact-popup').hide();
    }
  });

      //$('.template-product-essential .quick-add-modal__content .icon-close').on('click', function (e) {
      //location.reload();
    //});
});


  //MATRESS SHOW BUTTONS AFTER   
  window.addEventListener('load', function () {
    // Show product buttons after everything is fully loaded
    setTimeout(function() {
      $('.template-product-mattress .product-form-buy').show();
      $('.template-product-lusso-mattress .product-form-buy').show();
      $('.template-product-base-bedheads .product-form-buy').show();
    }, 1500); 
  });

  $('.bed-product .product-form__buttons .product-form__submit').prop('disabled', true);

  const postcodeInput = document.getElementById("inputField");
  const submitButton = document.getElementById("mattressbedSubmit");

    // Function to toggle button
  if(postcodeInput != null){
    postcodeInput.addEventListener("input", () => {
      if (postcodeInput.value.trim() !== "") {
        $('.bed-product .product-form__buttons .product-form__submit').prop('disabled', false);
      } else {
        $('.bed-product .product-form__buttons .product-form__submit').prop('disabled', true);
      }
    });
  }  

     //POSSUM CODE 
$(document).on('click', '#possum-signin', function(e) {
  e.preventDefault();
  $('.subscribe-popup-overlay').hide();
  $('.possum-popup-overlay')
    .css({
      'display': 'block',
      'visibility': 'visible',
      'opacity': '1'
    });
});    
$(document).on('click', '#possum-signin-drawer', function(e) {
  e.preventDefault();
  $('.subscribe-popup-overlay').hide();
  $('.possum-popup-overlay')
    .css({
      'display': 'block',
      'visibility': 'visible',
      'opacity': '1'
    });
}); 

$(document).on('click', '#select-gloves-drawer', function(e) {
  e.preventDefault();
  $('.subscribe-popup-overlay').hide();
  $('#free-gloves-modal').show();
}); 

    
$(document).on('click', 'form[action*="/cart/add"] [type="submit"]', function (e) {
  // Check if the clicked button has the class
  if ($(this).hasClass('possum-buy-button')) {
    $('.subscribe-popup-overlay').hide();
    $('.logged-in #free-gloves-modal').show();
    $('.possum-popup-overlay')
      .css({
        'display': 'block',
        'visibility': 'visible',
        'opacity': '1'
      });
  }
});


(function () {
  // Inject styles once
  function ensurePopupStyles() {
    if (document.getElementById('possum-popup-styles')) return;
    const style = document.createElement('style');
    style.id = 'possum-popup-styles';
    style.textContent = `
      .possum-modal-overlay {
        position: fixed; inset: 0; display: flex; align-items: center; justify-content: center;
        background: rgba(0,0,0,0.5); z-index: 99999; opacity: 0; pointer-events: none;
        transition: opacity .2s ease;
      }
      .possum-modal-overlay.is-open { opacity: 1; pointer-events: auto; }
      .possum-modal {
        width: 90%; max-width: 350px; background: rgb(187, 37, 42); color: #fff;
        border-radius: 10px; padding: 20px; text-align: center; box-shadow: 0 10px 30px rgba(0,0,0,.35);
        font-family: Arial, Helvetica, sans-serif;
      }
      .possum-modal h2 { margin: 0 0 12px; font-size: 18px; font-weight: 700; letter-spacing: .02em; }
      .possum-modal p { margin: 0 0 18px; line-height: 1.45; font-size: 14px; }
      .possum-modal .possum-close-btn {
        display: inline-block; border: 0; border-radius: 6px; padding: 10px 16px; cursor: pointer;
        background: #fff; color: rgb(187, 37, 42); font-weight: 700; font-size: 14px;
      }
      .possum-modal .possum-close-btn:focus { outline: 2px solid #fff; outline-offset: 2px; }
    `;
    document.head.appendChild(style);
  }

  function buildPopup() {
    ensurePopupStyles();

    // Remove existing instance if any
    const existing = document.getElementById('possum-modal-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'possum-modal-overlay';
    overlay.className = 'possum-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = `
      <div class="possum-modal" role="document">
        <h2>MEMBER OFFER</h2>
        <p>
          Your gloves have been added to your Cart.<br><br>
          Please close this window to select and add your Possum Item to Cart which will activate your Free Gloves* Discount Offer in your Cart.
        </p>
        <button type="button" class="possum-close-btn">Close</button>
      </div>
    `;

    document.body.appendChild(overlay);
    // small async tick for transition
    requestAnimationFrame(() => overlay.classList.add('is-open'));

    function close() {
      overlay.classList.remove('is-open');
      setTimeout(() => overlay.remove(), 200);
    }

    // Close on button
    overlay.querySelector('.possum-close-btn').addEventListener('click', close);
    // Close when clicking dim background
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    return overlay;
  }

  // Show popup (call after the button action you care about)
  function showPopup(e) {
    //if (e) e.preventDefault(); // stop form submits or default button actions
    setTimeout(function() {
      $('#free-gloves-modal').hide();
      buildPopup();
    }, 2000);     

  }

  // 1) Handle direct clicks on the button (works even if added later)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.possum-promo-gloves-container button');
    if (btn) {
      showPopup(e);
    }
  });

  // 2) Handle form submits where that button is the submitter
  document.addEventListener('submit', function (e) {
    // e.submitter is widely supported (incl. modern Firefox/Chrome)
    const submitter = e.submitter || document.activeElement;
    if (submitter && submitter.closest('.possum-promo-gloves-container')) {
      showPopup(e);
    }
  });
})();


//Append Badge to multicolumn
$('#home-new-arrival .home-col-links').each(function(){
    $(this).append('<span class="home-new-arrival-badge">New</span>');
});
$('.home-natural-fibres .rich-text__text p a:first-child').addClass('active-column');
$("[id*='multicolumn_9rLBFU']").addClass('active-grid-column');
$('.home-natural-fibres .rich-text__text p a').click(function(e){
  e.preventDefault();
  var getTitle = $(this).attr('title');
  console.log(getTitle);
  $('.home-natural-fibres .rich-text__text p a').removeClass('active-column');
  $(this).addClass('active-column');
  if(getTitle == '#new-arrivals'){
    $("[id*='multicolumn_N4mifK']").addClass('active-grid-column');  
    $("[id*='multicolumn_9rLBFU']").removeClass('active-grid-column');
    $("[id*='multicolumn_3tmAAU']").removeClass('active-grid-column');
    $("[id*='multicolumn_qjBmmM']").removeClass('active-grid-column');
  }
  if(getTitle == '#monthly-offers'){
    $("[id*='multicolumn_N4mifK']").removeClass('active-grid-column');
    $("[id*='multicolumn_9rLBFU']").addClass('active-grid-column');  
    $("[id*='multicolumn_3tmAAU']").removeClass('active-grid-column');
    $("[id*='multicolumn_qjBmmM']").removeClass('active-grid-column');
  }
  if(getTitle == '#end-of-season-sale'){
    $("[id*='multicolumn_N4mifK']").removeClass('active-grid-column');
    $("[id*='multicolumn_9rLBFU']").removeClass('active-grid-column');  
    $("[id*='multicolumn_qjBmmM']").addClass('active-grid-column');  
    $("[id*='multicolumn_3tmAAU']").removeClass('active-grid-column');
  }  
  if(getTitle == '#sale-items'){
    $("[id*='multicolumn_N4mifK']").removeClass('active-grid-column');
    $("[id*='multicolumn_9rLBFU']").removeClass('active-grid-column');
    $("[id*='multicolumn_3tmAAU']").addClass('active-grid-column');  
    $("[id*='multicolumn_qjBmmM']").removeClass('active-grid-column');
  }    
});
//[id*='multicolumn_N4mifK'],[id*='multicolumn_9rLBFU'],[id*='multicolumn_3tmAAU']


 $('.grid-options span').click(function(){
  if($(this).hasClass('grid-option-three')){
    $('.product-grid-container .product-grid').removeClass('product-grid-four');
    $('.product-grid-container .product-grid').addClass('product-grid-three');
  }
  if($(this).hasClass('grid-option-four')){
    $('.product-grid-container .product-grid').addClass('product-grid-four');
    $('.product-grid-container .product-grid').removeClass('product-grid-three');
  }  

 }); 


(function () {
  const PARENT_SEL = '.collection-description-rich-text';
  const CONTAINER_SEL = '.rich-text__text.rte';
  const TOGGLE_CLASS = 'collection-more-toggle';
  const HIDDEN_CLASS = 'hidden-content';

  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.moreInit === '1') return;
    const container = wrapper.querySelector(CONTAINER_SEL);
    if (!container) return;

    wrapper.dataset.moreInit = '1';

    const nodes = Array.from(container.querySelectorAll('p, h2, h3, h4, h5, h6'));
    if (nodes.length === 0) return;

    const firstParagraph = nodes.find(n => n.tagName === 'P');
    if (!firstParagraph) return;

    // find heading before the first paragraph
    let firstHeading = null;
    for (const node of nodes) {
      if (/^H[2-6]$/.test(node.tagName)) {
        if (node.compareDocumentPosition(firstParagraph) & Node.DOCUMENT_POSITION_PRECEDING) {
          firstHeading = node;
        }
        break;
      }
      if (node === firstParagraph) break;
    }

    // create hidden wrapper
    let hiddenWrapper = container.querySelector('.' + HIDDEN_CLASS);
    if (!hiddenWrapper) {
      hiddenWrapper = document.createElement('div');
      hiddenWrapper.className = HIDDEN_CLASS;
      container.appendChild(hiddenWrapper);
    }
    hiddenWrapper.style.display = 'none';

    // move everything except firstParagraph and optional firstHeading
    nodes.forEach(node => {
      if (node === firstParagraph || node === firstHeading) return;
      if (!node.closest('.' + HIDDEN_CLASS)) {
        hiddenWrapper.appendChild(node);
      }
    });

    // add toggle button
    if (container.querySelector('.' + TOGGLE_CLASS)) return;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = TOGGLE_CLASS;
    toggle.textContent = 'More';

    // place toggle initially after the first paragraph
    firstParagraph.appendChild(document.createTextNode(' '));
    firstParagraph.appendChild(toggle);

    toggle.addEventListener('click', function () {
      if (hiddenWrapper.style.display === 'none') {
        hiddenWrapper.style.display = 'block';
        toggle.textContent = 'Less';
        container.appendChild(toggle); // move button to bottom
      } else {
        hiddenWrapper.style.display = 'none';
        toggle.textContent = 'More';
        firstParagraph.appendChild(document.createTextNode(' '));
        firstParagraph.appendChild(toggle); // move button back up
      }
    });
  }

  document.querySelectorAll(PARENT_SEL).forEach(initWrapper);

  const observer = new MutationObserver(() => {
    document.querySelectorAll(PARENT_SEL).forEach(initWrapper);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => observer.disconnect(), 10000);
})();


//BADGE UPDATE
document.addEventListener("DOMContentLoaded", () => {
  const resultsSelector = ".ss__results.grid.product-grid";
  const productCache = new Map();

  async function getProductData(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error("Fetch failed");
      const data = await res.json();
      productCache.set(handle, data);
      return data;
    } catch (err) {
      console.warn("[Monthly Offers] Error fetching product:", handle, err);
      return null;
    }
  }

  async function processCard(card) {
    const linkEl = card.querySelector('a[href*="/products/"]');
    if (!linkEl) return;

    const handle = linkEl
      .getAttribute("href")
      .split("/products/")[1]
      .split("?")[0]
      .replace(/\/$/, "");

    const badgeContainer = card.querySelector(
      ".card__badge.top.right.ss__badge__container"
    );
    if (!badgeContainer) return;

    const product = await getProductData(handle);
    if (!product || !product.tags) return;

    const hasMonthlyOffer = product.tags.includes("Weekly Offer Sale");
    if (!hasMonthlyOffer) return;

    const saleBadge = badgeContainer.querySelector(".badge.ss__badge--sale");
    if (!saleBadge) return;

    // Replace text and classes cleanly
    //saleBadge.textContent = "April Offers";
    saleBadge.classList.remove("ss__badge--sale", "color-accent-2");
    saleBadge.classList.add("ss__badge--monthly-offer", "color-accent-1");
  }

  async function updateMonthlyOfferBadges() {
    const cards = document.querySelectorAll(".ss__result");
    if (!cards.length) return;
    await Promise.all([...cards].map(processCard));
  }

  function observeSearchspringResults() {
    const target = document.querySelector(resultsSelector);
    if (!target) {
      setTimeout(observeSearchspringResults, 300);
      return;
    }

    updateMonthlyOfferBadges();

    // React to Searchspring re-renders
    const observer = new MutationObserver(() => {
      clearTimeout(window._monthlyOfferTimer);
      window._monthlyOfferTimer = setTimeout(() => {
        updateMonthlyOfferBadges();
      }, 300);
    });

    observer.observe(target, { childList: true, subtree: true });

    // 🧹 Continuous Cleanup Loop: fix "Monthly OfferSale" if Searchspring re-appends
    setInterval(() => {
      document
        .querySelectorAll(".badge.ss__badge--monthly-offer")
        .forEach((badge) => {
          if (badge.textContent.trim() !== "April Offers") {
            //badge.textContent = "April Offers";
          }
        });
    }, 500); // every 0.5s ensures persistent correction
  }

  observeSearchspringResults();
});


document.addEventListener('DOMContentLoaded', () => {
  const mediaList = document.querySelector('.product__media-list');
  const badgeContainer = document.querySelector('.product-badge-container');
  if (!mediaList || !badgeContainer) return;

  // function to sync height
  function syncBadgeHeight() {
    // only on desktop (e.g. >= 750px width)
    if (window.innerWidth < 750) {
      badgeContainer.style.height = '';
      return;
    }

    const mediaHeight = mediaList.offsetHeight;
    badgeContainer.style.height = mediaHeight + 'px';
  }

  // initial sync
  syncBadgeHeight();

  // adjust when window resizes or content (like images) loads
  window.addEventListener('resize', syncBadgeHeight);
  window.addEventListener('load', syncBadgeHeight);

  // watch for changes to product media (e.g. variant change)
  const observer = new MutationObserver(syncBadgeHeight);
  observer.observe(mediaList, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", () => {
  // Event delegation: listen on the document, not the span
  document.addEventListener("click", (e) => {
    const span = e.target.closest(".yotpo-extra-text");
    if (!span) return; // only trigger if click is on a .yotpo-extra-text

    // Optional: visually indicate it's clickable
    span.style.cursor = "pointer";

    // Find Shopify section (partial match on id)
    const target = document.querySelector("[id*='17327492728c15bdd4']");

    if (target) {
      const headerOffset = 100; // adjust if you have a sticky header
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      // Optional: flash highlight effect
      target.style.transition = "background-color 0.6s ease";
      target.style.backgroundColor = "#fff8d6";
      setTimeout(() => target.style.backgroundColor = "", 1000);

    } else {
      console.warn("Target section not found in DOM at click time.");
    }
  });
});


setTimeout(function() {
  $('.product__info-wrapper .yotpo-widget-instance').show();
  $('.ss__result__inner .yotpo-widget-instance').show();
  
}, 4000);  



//FURTHER 20% OFF BADGE REMOVE IT ON FRIDAY

function applyFurtherBadges() {
    const items = document.querySelectorAll('.ss__result__image');

    items.forEach(item => {
        const content = item.querySelector('.card__content');
        if (!content) return;

        // prevent duplicates
        if (content.querySelector('.ss__badge--further-badge')) return;

        // get product title
        const titleEl = content.querySelector('.card__heading, .product-title, a[title], h3, h2');
        if (!titleEl) return;

        const title = titleEl.textContent.toLowerCase();

        // exclusions
        const excluded = ["mattress", "base", "bed head", "blanket box","essential merino","fine merino"];
        if (excluded.some(word => title.includes(word))) return;

        // build badge
        const badge = document.createElement('div');
        badge.className = "card__badge bottom right ss__badge__container card-badge-further";
        badge.innerHTML = `
            <span class="badge badge--bottom-right ss__badge--further-badge">
                20% Auto Discount
            </span>
        `;

        // ensure positioning
        content.style.position = "relative";

        content.appendChild(badge);
    });
}

//const observer = new MutationObserver(applyFurtherBadges);
//observer.observe(document.body, { childList: true, subtree: true });

//applyFurtherBadges();



//MERINO UPDATE
function applyMerinoBadges() {   // function name updated earlier
    const items = document.querySelectorAll('.ss__result__image');

    items.forEach(item => {
        const content = item.querySelector('.card__content');
        if (!content) return;

        // prevent duplicates
        if (content.querySelector('.ss__badge--merino-badge')) return; // updated class

        // get product title
        const titleEl = content.querySelector('.card__heading, .product-title, a[title], h3, h2');
        if (!titleEl) return;

        const title = titleEl.textContent.toLowerCase();

        // Only apply badge for these / Exclude if "pack"
        const isEligible = (title.includes("essential merino") || title.includes("fine merino"));
        const isPack = title.includes("pack");
        if (!isEligible || isPack) return;

        // build badge
        const badge = document.createElement('div');
        badge.className = "card__badge bottom right ss__badge__container card-badge-merino";
        badge.innerHTML = `
            <span class="badge badge--bottom-right ss__badge--merino-badge">
                up to 60% Off
            </span>
        `;

        // ensure positioning
        content.style.position = "relative";
        content.appendChild(badge);
    });
}

//const merinoObserver = new MutationObserver(applyMerinoBadges);
//merinoObserver.observe(document.body, { childList: true, subtree: true });

//applyMerinoBadges(); // run initial


//MATTRESSES BADGES
function applyMattressBadges() {
    const items = document.querySelectorAll('.ss__result__image');

    items.forEach(item => {
        const content = item.querySelector('.card__content');
        if (!content) return;

        // Prevent duplicate badge insertion
        if (content.querySelector('.ss__badge--mattress-badge')) return;

        // Grab product title
        const titleEl = content.querySelector('.card__heading, .product-title, a[title], h3, h2');
        if (!titleEl) return;

        const title = titleEl.textContent.toLowerCase();

        // Keywords for this function
        const keywords = ["mattress", "base", "bed head"];
        const matchesKeyword = keywords.some(word => title.includes(word));
        const isPack = title.includes("pack");

        // Only apply if matches AND not a pack
        if (!matchesKeyword || isPack) return;

        // Insert badge
        const badge = document.createElement('div');
        badge.className = "card__badge bottom right ss__badge__container card-badge-mattress";
        badge.innerHTML = `
            <span class="badge badge--bottom-right ss__badge--mattress-badge">
                40% Off
            </span>
        `;

        content.style.position = "relative";
        if(title.includes('baselayer')){}else{
          content.appendChild(badge);
        }
        
    });
}

function updateReturnsText() {
  if (!document.body.classList.contains('template-collection')) return;

  const returnLink = document.querySelector('a[href*="/return-exchange"]');

  if (returnLink && returnLink.textContent.includes('60 Day')) {
    returnLink.innerHTML = returnLink.innerHTML.replace('60 Day', '30 Day');
    return true;
  }

  return false;
}

document.addEventListener('DOMContentLoaded', function () {
  // Try immediately
  if (updateReturnsText()) return;

  // If not found, observe DOM changes (for sliders / lazy sections)
  const observer = new MutationObserver(() => {
    if (updateReturnsText()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("filterToggleBtn");
  const filters = document.getElementById("main-collection-filters");

  if (btn && filters) {
    btn.addEventListener("click", function () {
      filters.classList.toggle("active");

      // Optional: change text dynamically
      if (filters.classList.contains("active")) {
        btn.childNodes[0].textContent = "Hide Filters ";
        
      } else {
        btn.childNodes[0].textContent = "Show Filters ";
      }
      document.body.classList.toggle("show-filters");
    });
  }
});


(function () {
  function parsePrice(text) {
    if (!text) return null;
    return parseFloat(text.replace(/[^0-9.]/g, ''));
  }

  function lockBadge(badgeEl, text) {
    // Set correct text immediately
    badgeEl.textContent = text;

    // Prevent future modifications
    const observer = new MutationObserver(() => {
      if (badgeEl.textContent !== text) {
        badgeEl.textContent = text;
      }
    });

    observer.observe(badgeEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

function updateProduct(product) {
  const regularEl = product.querySelector('.price-item--regular');
  const saleEl = product.querySelector('.price-item--sale');

  const badgeEls = product.querySelectorAll(
    '.ss__badge--monthly-offer, .ss__badge--sale'
  );

  if (!regularEl || !saleEl || !badgeEls.length) return;

  // Get product title
  const titleEl = product.querySelector('.card__heading a, .card__heading');
  const productTitle = titleEl?.textContent?.trim() || '';

  let text = '';

  // Custom text for Heritage blanket products
  if (productTitle.includes('Heritage Merino Wool Blanket')) {
    text = `Intro Offer - 50% Off`;

    // Add separate bottom-right New badge below the existing badge
    const saleBadgeContainer = product.querySelector(
      '.card__badge.top.right.ss__badge__container'
    );

    if (
      saleBadgeContainer &&
      !product.querySelector('.ss__badge--new')
    ) {
      saleBadgeContainer.insertAdjacentHTML(
        'afterend',
        `
        <div class="card__badge bottom right ss__badge__container card-heritage-badge">
          <span
            class="badge badge--bottom-left color-accent-2 ss__badge--new ss__badge--new-heritage"
            style="background:rgb(56, 66, 47) !important;"
          >
            New
          </span>
        </div>
        `
      );
    }
  } else {
    const regularPrice = parsePrice(regularEl.textContent);
    const salePrice = parsePrice(saleEl.textContent);

    if (!regularPrice || !salePrice || regularPrice <= salePrice) return;

    const percentOff = Math.round(
      ((regularPrice - salePrice) / regularPrice) * 100
    );

    text = `Up to ${percentOff}% OFF`;
  }

  badgeEls.forEach(badgeEl => {
    if (badgeEl.dataset.locked === 'true') return;

    lockBadge(badgeEl, text);
    badgeEl.dataset.locked = 'true';
  });
}

  function processAllProducts() {
    document.querySelectorAll('.ss__result').forEach(updateProduct);
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', processAllProducts);

  // Searchspring render
  document.addEventListener('searchspring:render', processAllProducts);

  // 🔥 CRITICAL: Detect "Load More" injected products
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        // New product cards from "Load More"
        if (node.matches?.('.ss__result')) {
          updateProduct(node);
        }

        // Sometimes products are nested inside wrappers
        node.querySelectorAll?.('.ss__result').forEach(updateProduct);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

document.addEventListener("DOMContentLoaded", function () {

  const STICKY_OFFSET = 800; // 🔧 adjust this (150–300 is usually ideal)

  function initStickyFilter() {
    const filterBar = document.querySelector(".filter-toggle");
    if (!filterBar) return;

    // Prevent duplicate init
    if (filterBar.classList.contains("sticky-initialized")) return;
    filterBar.classList.add("sticky-initialized");

    // Create placeholder to prevent layout jump
    const placeholder = document.createElement("div");
    placeholder.className = "filter-placeholder";
    filterBar.parentNode.insertBefore(placeholder, filterBar.nextSibling);

    let triggerPoint = 0;

    function updateMeasurements() {
      const baseTop = placeholder.offsetTop || filterBar.offsetTop;

      // ✅ ADD offset (not subtract)
      triggerPoint = baseTop + STICKY_OFFSET;

      placeholder.style.height = filterBar.offsetHeight + "px";
    }

    updateMeasurements();

    function handleScroll() {
      const shouldStick = window.scrollY >= triggerPoint;

      if (shouldStick) {
        if (!filterBar.classList.contains("is-sticky")) {
          filterBar.classList.add("is-sticky");
          placeholder.classList.add("active");
        }
      } else {
        filterBar.classList.remove("is-sticky");
        placeholder.classList.remove("active");
      }
    }

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", updateMeasurements);
  }

  // Initial run
  initStickyFilter();

  // 🔥 Searchspring compatibility hooks
  document.addEventListener("searchspring.render", initStickyFilter);
  document.addEventListener("searchspring.pagination", initStickyFilter);

  // Fallback observer (handles dynamic reloads)
  const observer = new MutationObserver(() => {
    initStickyFilter();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});


// auto change the link to color
document.addEventListener("DOMContentLoaded", function () {

  const colorMap = {
    blue: "#005b96",
    brown: "#8B4513",
    cream: "#f5f5dc",
    green: "#6a6943",
    grey: "#808080",
    gray: "#808080",
    pink: "#e4b1b1",
    red: "#ad0a01",
    white: "#FFFFFF",
    black: "#000000",
    orange: "#E28508",
    purple: "#510400",
    yellow: "#fce072",
    gold: "#FFD700",
    multi:"linear-gradient(to right, #ad0a01, #E28508, #fce072, #6a6943, #005b96, #510400)"
  };

  function applyColorSwatches() {
    const links = document.querySelectorAll(".mega-menu__link,.menu-drawer__menu-item");

    if (!links.length) return;

    links.forEach(link => {

      // ✅ Clean and normalize text
      let colorKey = link.textContent
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();

      // ✅ Skip if not a mapped color
      if (!colorMap[colorKey]) return;

      // ✅ Prevent duplicates (important for re-renders)
      if (link.querySelector(".color-menu-swatch")) return;

      const swatch = document.createElement("span");
      swatch.className = "color-menu-swatch";
      swatch.style.backgroundColor = colorMap[colorKey];

      // ✅ Make light colors visible
      if (colorKey === "white" || colorKey === "cream") {
        swatch.style.border = "1px solid #ccc";
      }
      if(colorKey === "multi"){
        swatch.style.background = 'linear-gradient(to right, #ad0a01, #E28508, #fce072, #6a6943, #005b96, #510400)';
      }

      link.prepend(swatch);
    });
  }

  // ✅ Run once
  applyColorSwatches();

  // ✅ Run again in case Shopify/Searchspring reloads menu
  setTimeout(applyColorSwatches, 500);
  setTimeout(applyColorSwatches, 1500);

});



// PDP VARIANT IMAGES
document.addEventListener("DOMContentLoaded", function () {

  function getSelectedColor() {

    const fieldsets = document.querySelectorAll(".product-form__input");

    for (let fieldset of fieldsets) {

      const text = fieldset.innerText.toLowerCase();

      if (text.includes("color") || text.includes("colour")) {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;
      }
    }

    return null;
  }

function filterThumbnails() {

  const selectedColor = getSelectedColor();
  if (!selectedColor) return;

  const cleanColor = selectedColor
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/[^a-z0-9]/g, "");

  // THUMBNAILS
  document
    .querySelectorAll(".thumbnail-list [data-media-filename]")
    .forEach(thumb => {

      const filename = (thumb.dataset.mediaFilename || "")
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/[^a-z0-9]/g, "");

      thumb.hidden = !filename.includes(cleanColor);
    });

  // MAIN IMAGES
  const slides = document.querySelectorAll(
    ".product__media-item[data-media-filename]"
  );

  let firstVisibleSlide = null;

  slides.forEach(slide => {

    const filename = (slide.dataset.mediaFilename || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "");

    const match = filename.includes(cleanColor);

    slide.style.display = match ? '' : 'none';

    if (match && !firstVisibleSlide) {
      firstVisibleSlide = slide;
    }
  });

  if (firstVisibleSlide) {

    slides.forEach(slide => {
      slide.classList.remove("is-active");
    });

    firstVisibleSlide.classList.add("is-active");

    firstVisibleSlide.scrollIntoView({
      behavior: "auto",
      block: "nearest",
      inline: "center"
    });
  }
}

  // Page load
  setTimeout(filterThumbnails, 1000);

  // Variant change
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[type="radio"]')) {
      setTimeout(filterThumbnails, 700);
    }
  });

});



//STICKY ADD TO CART 
document.addEventListener("DOMContentLoaded", function(){

  const stickyBar = document.querySelector(".premium-sticky-atc");
  const stickyBtn = document.querySelector(".premium-atc-btn");
  const originalBtn = document.querySelector(".product-form__submit");

  if(!stickyBar || !originalBtn) return;

  const title = document.querySelector(".product__title h1")?.innerText || "";
  const titleEl = document.querySelector(".premium-atc-title");
  const variantEl = document.querySelector(".premium-atc-variant");
  const priceEl = document.querySelector(".premium-atc-price");
  const imageEl = document.querySelector(".premium-atc-image");

  titleEl.textContent = title;

function updateStickyBar(){

  const container = document.querySelector(".product__info-container");
  if(!container) return;

  let selectedValues = [];

  container.querySelectorAll('input[type="radio"]:checked').forEach(input => {
    if(input.value) selectedValues.push(input.value.trim());
  });

  container.querySelectorAll("select").forEach(select => {
    const val = select.options[select.selectedIndex]?.text.trim();

    if(val && !selectedValues.includes(val)){
      selectedValues.push(val);
    }
  });

  document.querySelector(".premium-atc-variant").textContent =
    selectedValues.join(" / ");

  /* INSTANT PRICE FROM SELECTED VARIANT */
  const variantInput = container.querySelector('[name="id"]');

  if(variantInput){

    const variantId = variantInput.value;

    const jsonScript = document.querySelector('script[type="application/json"]');

    if(jsonScript){

      try{

        const data = JSON.parse(jsonScript.textContent);

        const variant = data.find(v => String(v.id) === String(variantId));

        if(variant){

          const price = "$" + (variant.price / 100).toFixed(2);

          document.querySelector(".premium-atc-price").textContent = price;
        }

      }catch(e){}
    }
  }

  /* IMAGE */
  const mainImg =
    document.querySelector(".product__media img") ||
    document.querySelector(".media img");

  if(mainImg){
    document.querySelector(".premium-atc-image").src = mainImg.src;
  }

}
function updateStickyPrice(){

  const container = document.querySelector(".product__info-container");

  if(!container) return;

  const price =
    container.querySelector(".price-item--sale")?.innerText.trim() ||
    container.querySelector(".price-item--regular")?.innerText.trim() ||
    container.querySelector(".price .price-item")?.innerText.trim() ||
    container.querySelector(".price")?.innerText.trim() ||
    "";

  document.querySelector(".premium-atc-price").textContent = price;
}

  function toggleSticky(){

    const rect = originalBtn.getBoundingClientRect();

    const visible =
      rect.top < window.innerHeight &&
      rect.bottom > 0;

    if(visible){
      stickyBar.classList.remove("show");
    }else{
      stickyBar.classList.add("show");
    }
  }

  window.addEventListener("scroll", toggleSticky);
  window.addEventListener("resize", toggleSticky);

  document.body.addEventListener("change", updateStickyBar);

  stickyBtn.addEventListener("click", function(){
    originalBtn.click();
  });

  updateStickyBar();
  toggleSticky();

});

document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.querySelector(".premium-atc-btn");

  if (!stickyBtn) return;

  const originalText = stickyBtn.innerHTML;

  stickyBtn.addEventListener("click", function () {
    // Prevent double clicks
    if (stickyBtn.classList.contains("loading")) return;

    stickyBtn.classList.add("loading");
    stickyBtn.disabled = true;

    stickyBtn.innerHTML = `
      <span class="spinner"></span>
      Adding...
    `;

    // Reset after Shopify finishes
    setTimeout(() => {
      stickyBtn.classList.remove("loading");
      stickyBtn.disabled = false;
      stickyBtn.innerHTML = originalText;
    }, 2500);
  });
});

document.addEventListener('click', function(e) {
  const trigger = e.target.closest('#cart-icon-bubble');
  if (!trigger) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  e.preventDefault();

  drawer.open?.();
});

//WAVERLY MILLS

//function applyNoSnippet() {
  //document.querySelectorAll('.morecontent').forEach(container => {
    //if (!container.innerHTML.includes('data-nosnippet')) {
      //container.innerHTML = container.innerHTML.replace(
        ///Waverley Mills/gi,
        //'<span data-nosnippet>$&</span>'
      //);
    //}
  //});
//}

//applyNoSnippet();

//const observer = new MutationObserver(() => {
 // applyNoSnippet();
//});

//observer.observe(document.body, {
//  childList: true,
//  subtree: true
//});



//Collection title update:
document.addEventListener('DOMContentLoaded', function () {
  const heading = document.querySelector(
    '.collection-description-rich-text .rich-text__heading.rte.h1 span'
  );

  if (!heading) return;

  let text = heading.textContent.trim();

  // Remove trailing "s" from the last word
  text = text.replace(/(\w+)s\b$/, '$1');

  // Determine whether to use "a" or "an"
  const article = /^[aeiou]/i.test(text) ? 'an' : 'a';

  // Update heading text
  heading.textContent = `Discover ${article} ${text} today`;
});



//H2 UPDATE
window.addEventListener('load', () => {
  if (!document.body.classList.contains('template-collection')) return;

  requestAnimationFrame(() => {
    document
      .querySelectorAll('#id-collection-description-rich-text h2')
      .forEach(h2 => {
        const h3 = document.createElement('h3');

        [...h2.attributes].forEach(attr => {
          h3.setAttribute(attr.name, attr.value);
        });

        h3.innerHTML = h2.innerHTML;
        h2.replaceWith(h3);
      });
  });
});

document.addEventListener('DOMContentLoaded', function() {

  if (window.innerWidth > 749) return;

  const slider = document.querySelector('.main-product-info-icons');
  const slides = slider?.querySelectorAll('.add-prod-info-divs');

  if (!slider || slides.length <= 1) return;

  let current = 0;
  let autoScroll;

  function startAutoScroll() {
    autoScroll = setInterval(() => {
      current = (current + 1) % slides.length;

      slider.scrollTo({
        left: slider.clientWidth * current,
        behavior: 'smooth'
      });
    }, 4000);
  }

  function stopAutoScroll() {
    clearInterval(autoScroll);
  }

  slider.addEventListener('touchstart', stopAutoScroll);
  slider.addEventListener('touchend', () => {
    setTimeout(startAutoScroll, 5000);
  });

  startAutoScroll();

});

// Mobile breadcrumb navigation
document.addEventListener('DOMContentLoaded', function () {

  const list = document.querySelector('.breadcrumbs__list');
  const prev = document.querySelector('.breadcrumb-nav--prev');
  const next = document.querySelector('.breadcrumb-nav--next');

  if (!list || !prev || !next) return;

  function updateBreadcrumbNav() {

    const maxScroll =
      list.scrollWidth - list.clientWidth;

    prev.classList.toggle(
      'is-hidden',
      list.scrollLeft <= 5
    );

    next.classList.toggle(
      'is-hidden',
      list.scrollLeft >= maxScroll - 5
    );

    // hide both if no overflow
    if (maxScroll <= 0) {
      prev.classList.add('is-hidden');
      next.classList.add('is-hidden');
    }
  }

  prev.addEventListener('click', function () {
    list.scrollBy({
      left: -150,
      behavior: 'smooth'
    });
  });

  next.addEventListener('click', function () {
    list.scrollBy({
      left: 150,
      behavior: 'smooth'
    });
  });

  list.addEventListener('scroll', updateBreadcrumbNav);
  window.addEventListener('resize', updateBreadcrumbNav);

  updateBreadcrumbNav();
});